import React, { Component, useRef } from "react";
import JSZip from "jszip";
import pako from "pako";
import { Link } from "react-router-dom";
import DashboardHeader from "../../Header/DashboardHeader";
import DashboardFooter from "../../Footer/DashboardFooter";
import DashboardLeftMenu from "../../Dashboard/DashboardLeftMenu";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faEye,
  faArrowDown,
  faArrowUp,
  faDownload,
  faTrashAlt,
  faAddressBook,
  faInfoCircle,
  faCalendarAlt,
  faTimes,
  faSpinner,
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import EmptyImg from "../../Dashboard/assets/img/create-project.png";
import "react-datepicker/dist/react-datepicker.css";
import { HOST_URL, HOST_URL_DB2, NODE_HOST_URL, NODE_HOST_URL_v1 } from "../api/Api";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import Spining from "../../UI/Spining/Spining";
import { IoLogoWhatsapp } from "react-icons/io";
import { BiBorderRadius } from "react-icons/bi";
import { FaSms, FcSms } from "react-icons/fa";
import { WHATSAPP_TEMPLATE_LIST } from "../../../constants/ServiceConstants";
import WhatsAppCampaignListPreview from "../whatsapp/components/WhatsappCampaignListPreview";
import dayjs from "dayjs";
import DatePicker from "react-datepicker";
import Axios from "../../../axios/Axios";
import { FaMessage } from "react-icons/fa6";
import RcsImage from "../../Dashboard/assets/img/rcs.svg-removebg-preview.png";
import RecordImage from "../../Dashboard/assets/img/ph_stack-fill.svg"
import { CgLayoutGrid } from "react-icons/cg";
import "../assets/css/InsightPopup.css";



class CampaignList extends Component {
  constructor(props) {
    const lStorage = JSON.parse(localStorage.getItem("login"));
    const userId = lStorage?.user?.userId;
    const userToken = lStorage?.token;
    const userType = lStorage?.user?.isAdmin


    super();
    this.state = {
      campaignList: [],
      user_id: userId,
      token: userToken,
      type: userType,
      channel: "all",
      successShow: false,
      successMessage: "",
      bgColor: "",
      startDate: new Date(),
      endDate: new Date(),
      maxDate: null,
      loading: false,
      loadingBtn: false,
      totalData: 0,
      totalCost: 0,
      totalDelivered: 0,
      totalFailed: 0,
      totalRead: 0,
      totalSent: 0,
      totalDND: 0,
      totalOptOut: 0,
      openTemplatePopup: false,
      templateDetails: [],
      route: "",
      openReschedulePopup: false,
      selectedDate: null,
      rescheduleid: '',
      rescheduleName: '',
      deletePopup: false,
      deleteWhatsappPopup: false,
      deleteId: '',
      deleteCampaignName: '',
      deleteWhatsappId: '',
      deleteWhatsappCampaignName: '',
      openAccordion: [],
      fallbackData: '',
      totalWhatsapp: '',
      totalSms: '',
      totalRcs: '',
      search: '',
      numberFilterSearch: false,
      templateSummary: false,
      daywisesummary: false,
      campaignReport: true,
      deleteSmsId: '',
      deleteSmsCampaignName: '',
      campaignType: '',
      rcsdeliver: 0,
      rcsfailed: 0,
      rcsread: 0,
      rcssent: 0,
      rcscontactcount: 0,
      totalRcsData: 0,
      smsDelivered: 0,
      smsSubmission: 0,
      smsOther: 0,
      smsFailed: 0,
      smsOptOut: 0,
      smsDnd: 0,
      smsCost: 0,
      whatsappDelivered: 0,
      whatsappSubmission: 0,
      whatsappOther: 0,
      whatsappOptout: 0,
      whatsappFailed: 0,
      whatsappRead: 0,
      whatsappSent: 0,
      whatsappCost: 0,
      whatsappUtilityDelivered: 0,
      whatsappUtilitySubmission: 0,
      whatsappUtilityOther: 0,
      whatsappUtilityOptout: 0,
      whatsappUtilityFailed: 0,
      whatsappUtilityRead: 0,
      whatsappUtilitySent: 0,
      whatsappUtilityCost: 0,
      whatsappMarketingDelivered: 0,
      whatsappMarketingSubmission: 0,
      whatsappMarketingOther: 0,
      whatsappMarketingOptout: 0,
      whatsappMarketingFailed: 0,
      whatsappMarketingRead: 0,
      whatsappMarketingSent: 0,
      whatsappMarketingCost: 0,
      whatsappAuthnDelivered: 0,
      whatsappAuthnSubmission: 0,
      whatsappAuthnOther: 0,
      whatsappAuthnOptout: 0,
      whatsappAuthnFailed: 0,
      whatsappAuthnRead: 0,
      whatsappAuthnSent: 0,
      whatsappAuthnCost: 0,
      rcsDelivered: 0,
      rcsSubmission: 0,
      rcsFailed: 0,
      rcsRead: 0,
      rcsSent: 0,
      rcsCost: 0,
      scheduleReport: false,
      whatsappFullDetails: false,
      startDateTemplate: new Date(),
      endDateTemplate: new Date(),
      templateSummaryList: {},
      templateChannel: "",
      successTemplateShow: false,
      successTemplateMessage: "",
      bgColorTemplate: "",
      totalWhatsapp: 0,
      deliveredWhatsapp: 0,
      failedWhatsapp: 0,
      sentWhatsapp: 0,
      readWhatsapp: 0,
      optoutWhatsapp: 0,
      otherWhatsapp: 0,
      totalSms: 0,
      deliveredSms: 0,
      failedSms: 0,
      dndSms: 0,
      otherSms: 0,
      daywiseChannel: "",
      daywiseSummaryList: {},
      startDatedaywise: new Date(),
      endDatedaywise: new Date(),
      successDaywiseShow: false,
      successdaywiseMessage: "",
      bgColorDaywise: "",
      totalDaywiseData: 0,
      totalDaywiseDeliver: 0,
      totalDaywiseFailed: 0,
      totalDaywiseSent: 0,
      totalDaywiseRead: 0,
      totalDaywiseOptout: 0,
      totalDaywiseOther: 0,
      totalDaywiseDnd: 0,
      insightDataSummary: [],
      insightDataDetails: [],
      openInsightPopup: false,
      activeIndex: 1,
      insight_template_id: '',
      totalPages: 0,
      InsightDetailsShow: false,
      searchbtnName: "",
      encryptData: {},
      searchbtnName: "",
      // currentPage: 1,
      // itemsPerPage: 5
      nextPageUrl: "",
      previousPageUrl: "",
      insightLoading: false,
      contactCountPopup: false,
      contactCountSummary: "",
      InsightTotal: "",
      InsightDelivered: "",
      InsightFailed: "",
      InsightSent: "",
      InsightRead: "",
      InsightOptout: "",
      InsightOther: "",
      InsightDetailsShow: false,
      insightDataDetails: [],
      insightDetailsLoading: false,
      activeInsightBtnName: "",
      detailCurrentPage: 1,
      detailTotalPages: 1,
      detailTotalRecords: 0,
      detailSearchQuery: "",
      downloadingCampaigns: {}, // Track which campaigns are downloading
      clickReportModal: false,
      clickReportLoading: false,
      clickReportSummary: [],
      clickReportPage: 1,
      clickReportTotalPages: 1,
      clickReportTotalCount: 0,
      clickReportDownloading: {}
    };
    this.channelHandler = this.channelHandler.bind(this);
  }

  componentDidMount() {
    this.getCampaignList("all");
    this.getRoute();
    this.FetchEnableDownload();
  }

  getRoute = async () => {
    try {
      let response = await fetch(`${HOST_URL}/get_user_route.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json", // tell server body is JSON
        },
        body: JSON.stringify({
          user_id: this.state.user_id,
          method: "retrieve",
          token: this.state.token,
        }),
      });

      let result = await response.json();
      if (result.success) {
        this.setState({ route: result.data });
      }
    } catch (error) {
      console.error("Error fetching route:", error);
    }
  };


  currentDate(currentDate) {
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  }

  addDays(date) {
    const days = 30;
    const newDate = new Date(date);
    newDate.setDate(date.getDate() + days);
    return newDate;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.startDate !== this.state.startDate) {
      let maxDatee = this.addDays(this.state.startDate)
      this.setState({
        maxDate: maxDatee
      })
    }
  }

  getCampaignList(channel) {
    this.setState({ loading: true });
    this.setState({ loadingBtn: true });
    let sDate = this.currentDate(this.state.startDate);
    let eDate = this.currentDate(this.state.endDate);

    let urls = [];
    let dataList = [];
    if (channel === "sms" || channel === "all") {
      urls.push(`${HOST_URL_DB2}/bulk_campaign_sms.php`);
      dataList.push({
        user_id: this.state.user_id,
        method: "retrieve_new",
        token: this.state.token,
        channel: "sms",
        from_date: sDate,
        to_date: eDate
      });

    }
    if (channel === "whatsapp" || channel === "all") {
      urls.push(`${HOST_URL}/bulk_campaign_sms.php`);
      dataList.push({
        user_id: this.state.user_id,
        method: "retrieve_new",
        token: this.state.token,
        channel: "whatsapp",
        from_date: sDate,
        to_date: eDate
      });
    }
    if (channel === "rcs" || channel === "all") {
      urls.push(`${NODE_HOST_URL_v1}/rcsCampReport`);
      dataList.push({
        user_id: this.state.user_id,
        method: "campaign_report",
        token: this.state.token,
        from_date: sDate,
        to_date: eDate
      });

    }

    // Making all API calls
    Promise.all(
      urls.map((url, index) =>
        fetch(url, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(dataList[index])
        })
          .then(response => {
            const ct = response.headers.get("content-type") || "";
            if (ct.includes("application/json")) {
              return response.json();
            }
            return { success: false, data: [] };
          })
          .catch(() => ({ success: false, data: [] }))
      )
    )

      .then((results) => {
        let totalCost = 0;
        let totaldelivered = 0;
        let totalsent = 0;
        let totalread = 0;
        let totalfailed = 0;
        let contactCount = 0;
        let totalRcsDelivered = 0;
        let totalRcsFailed = 0;
        let totalRcsRead = 0;
        let totalRcsSent = 0;
        let rcsContactCount = 0
        let totalRcsData = 0
        let allData = [];

        //channel wise data
        let smsDelivered = 0
        let smsSubmission = 0
        let smsOther = 0
        let smsFailed = 0
        let smsOptOut = 0
        let smsDnd = 0
        let smsCost = 0
        let whatsappDelivered = 0
        let whatsappSubmission = 0
        let whatsappOther = 0
        let whatsappOptout = 0
        let whatsappFailed = 0
        let whatsappRead = 0
        let whatsappSent = 0
        let whatsappCost = 0
        let whatsappUtilityDelivered = 0
        let whatsappUtilitySubmission = 0
        let whatsappUtilityOther = 0
        let whatsappUtilityOptout = 0
        let whatsappUtilityFailed = 0
        let whatsappUtilityRead = 0
        let whatsappUtilitySent = 0
        let whatsappUtilityCost = 0
        let whatsappMarketingDelivered = 0
        let whatsappMarketingSubmission = 0
        let whatsappMarketingOther = 0
        let whatsappMarketingOptout = 0
        let whatsappMarketingFailed = 0
        let whatsappMarketingRead = 0
        let whatsappMarketingSent = 0
        let whatsappMarketingCost = 0
        let whatsappAuthnDelivered = 0
        let whatsappAuthnSubmission = 0
        let whatsappAuthnOther = 0
        let whatsappAuthnOptout = 0
        let whatsappAuthnFailed = 0
        let whatsappAuthnRead = 0
        let whatsappAuthnSent = 0
        let whatsappAuthnCost = 0
        let rcsDelivered = 0
        let rcsSubmission = 0
        let rcsFailed = 0
        let rcsRead = 0
        let rcsSent = 0
        let rcsCost = 0

        results.forEach((x) => {
          if (x.success === false) {
            return;
          }
          x.data.forEach((campData) => {
            const camp = campData
            if (camp.campaign_type === "sms") {
              smsDelivered += parseInt(camp.delivered) || 0
              smsSubmission += parseInt(camp.contact_count) || 0
              smsFailed += parseInt(camp.failed) || 0
              smsOther += parseInt(camp.other) || 0
              smsOptOut += parseInt(camp.optout) || 0
              smsDnd += parseInt(camp.dnd) || 0
              smsCost += camp.status === 4 ? 0 : parseFloat(camp.campaign_cost) || 0
            }
            if (camp.campaign_type === "whatsapp") {
              whatsappDelivered += parseInt(camp.delivered) || 0
              whatsappSubmission += parseInt(camp.delivered + camp.failed + camp.optout + camp.read + camp.sent) || 0
              whatsappOther += parseInt(camp.other) || 0
              whatsappOptout += parseInt(camp.optout)
              whatsappFailed += parseInt(camp.failed) || 0
              whatsappRead += parseInt(camp.read) || 0
              whatsappSent += parseInt(camp.sent) || 0
              whatsappCost += camp.status === 6 ? 0 : parseFloat(camp.campaign_cost) || 0
              if (camp.message_type === 1) {
                whatsappMarketingDelivered += parseInt(camp.delivered) || 0
                whatsappMarketingSubmission += parseInt(camp.delivered + camp.failed + camp.optout + camp.read + camp.sent) || 0
                whatsappMarketingOther += parseInt(camp.other) || 0
                whatsappMarketingOptout += parseInt(camp.optout)
                whatsappMarketingFailed += parseInt(camp.failed) || 0
                whatsappMarketingRead += parseInt(camp.read) || 0
                whatsappMarketingSent += parseInt(camp.sent) || 0
                whatsappMarketingCost += parseInt(camp.campaign_cost) || 0
              }
              if (camp.message_type === 2) {
                whatsappUtilityDelivered += parseInt(camp.delivered) || 0
                whatsappUtilitySubmission += parseInt(camp.delivered + camp.failed + camp.optout + camp.read + camp.sent) || 0
                whatsappUtilityOther += parseInt(camp.other) || 0
                whatsappUtilityOptout += parseInt(camp.optout)
                whatsappUtilityFailed += parseInt(camp.failed) || 0
                whatsappUtilityRead += parseInt(camp.read) || 0
                whatsappUtilitySent += parseInt(camp.sent) || 0
                whatsappUtilityCost += parseInt(camp.campaign_cost) || 0
              }
              if (camp.message_type === 3) {
                whatsappAuthnDelivered += parseInt(camp.delivered) || 0
                whatsappAuthnSubmission += parseInt(camp.delivered + camp.failed + camp.optout + camp.read + camp.sent) || 0
                whatsappAuthnOther += parseInt(camp.other) || 0
                whatsappAuthnOptout += parseInt(camp.optout)
                whatsappAuthnFailed += parseInt(camp.failed) || 0
                whatsappAuthnRead += parseInt(camp.read) || 0
                whatsappAuthnSent += parseInt(camp.sent) || 0
                whatsappAuthnCost += parseInt(camp.campaign_cost) || 0
              }

            }
            if (camp._id) {
              rcsDelivered += parseInt(camp.deliver_count) || 0
              rcsSubmission += parseInt(camp.contact_count) || 0
              rcsFailed += parseInt(camp.fail_count) || 0
              rcsRead += parseInt(camp.read_count) || 0
              rcsSent += parseInt(camp.sent_count) || 0
              rcsCost += camp.status === 4 ? 0 : parseFloat(camp.block_cr) || 0
            }
          })
        })

        results.forEach((result) => {
          if (result.success === true) {
            let data = result?.data?.map((item) => {
              let intValue = parseFloat(item.campaign_cost ? item.campaign_cost : item.block_cr);
              totalCost += intValue;
              totaldelivered += item.delivered;
              totalsent += item.sent
              totalread += item.read
              totalfailed += item.failed
              contactCount += item.contact_count
              totalRcsDelivered += item.deliver_count;
              totalRcsFailed += item.fail_count;
              totalRcsRead += item.read_count;
              totalRcsSent += item.sent_count;
              rcsContactCount += item.contact_count
              totalRcsData += item.block_cr
              return { ...item, channel: result.channel || channel, user_token: this.state.token };
            });
            allData = allData.concat(data); // Merging all campaign data
          }
        });

        let totalWhatsapp = allData.filter(x => x.campaign_type === "whatsapp").length;
        let totalSms = allData.filter(x => x.campaign_type === "sms").length;
        let totalRcs = allData.filter(x => x._id).length;

        const sorted = allData.sort((a, b) => new Date(b.camp_start_datetime) - new Date(a.camp_start_datetime));
        const filteredArray = sorted.filter(item => item.fb_requestid == null);

        this.setState({
          campaignList: this.state.channel === 'all' ? filteredArray : sorted,
          totalData: contactCount,
          totalCost: totalCost,
          totalDelivered: totaldelivered,
          totalFailed: totalfailed,
          totalRead: totalread,
          totalSent: totalsent,
          totalWhatsapp: totalWhatsapp,
          totalSms: totalSms,
          totalRcs: totalRcs,
          rcsdeliver: totalRcsDelivered,
          rcsfailed: totalRcsFailed,
          rcsread: totalRcsRead,
          rcssent: totalRcsSent,
          rcscontactcount: rcsContactCount,
          totalRcsData: totalRcsData,
          openAccordion: []
        });

        this.setState({
          openAccordion: [],
          smsDelivered: smsDelivered,
          smsSubmission: smsSubmission,
          smsFailed: smsFailed,
          smsOther: smsOther,
          smsOptOut: smsOptOut,
          smsDnd: smsDnd,
          smsCost: smsCost.toFixed(2),
          whatsappDelivered: whatsappDelivered,
          whatsappSubmission: whatsappSubmission,
          whatsappOther: whatsappOther,
          whatsappOptout: whatsappOptout,
          whatsappFailed: whatsappFailed,
          whatsappRead: whatsappRead,
          whatsappSent: whatsappSent,
          whatsappCost: whatsappCost.toFixed(2),
          whatsappUtilityDelivered: whatsappUtilityDelivered,
          whatsappUtilitySubmission: whatsappUtilitySubmission,
          whatsappUtilityOther: whatsappUtilityOther,
          whatsappUtilityOptout: whatsappUtilityOptout,
          whatsappUtilityFailed: whatsappUtilityFailed,
          whatsappUtilityRead: whatsappUtilityRead,
          whatsappUtilitySent: whatsappUtilitySent,
          whatsappUtilityCost: whatsappUtilityCost,
          whatsappMarketingDelivered: whatsappMarketingDelivered,
          whatsappMarketingSubmission: whatsappMarketingSubmission,
          whatsappMarketingOther: whatsappMarketingOther,
          whatsappMarketingOptout: whatsappMarketingOptout,
          whatsappMarketingFailed: whatsappMarketingFailed,
          whatsappMarketingRead: whatsappMarketingRead,
          whatsappMarketingSent: whatsappMarketingSent,
          whatsappMarketingCost: whatsappMarketingCost,
          whatsappAuthnDelivered: whatsappAuthnDelivered,
          whatsappAuthnSubmission: whatsappAuthnSubmission,
          whatsappAuthnOther: whatsappAuthnOther,
          whatsappAuthnOptout: whatsappAuthnOptout,
          whatsappAuthnFailed: whatsappAuthnFailed,
          whatsappAuthnRead: whatsappAuthnRead,
          whatsappAuthnSent: whatsappAuthnSent,
          whatsappAuthnCost: whatsappAuthnCost,
          rcsDelivered: rcsDelivered,
          rcsSubmission: rcsSubmission,
          rcsFailed: rcsFailed,
          rcsRead: rcsRead,
          rcsSent: rcsSent,
          rcsCost: rcsCost.toFixed(2),
        });

        this.setState({ loadingBtn: false });
        this.CampaignData(allData);
      })
      .catch((error) => {
        this.setState({
          campaignList: null,
          loadingBtn: false,
        });
        console.error("Error fetching campaign data: ", error);
      });

    this.setState({ loading: false });
  }


  deletecampaignList(id) {
    document.querySelector("body").scrollTo(0, 0);
    fetch(
      `${HOST_URL}/email_campaign.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        user_id: this.state.user_id,
        id: id,
        method: "delete",
        token: this.state.token
      })
    }).then((response) => {
      response.json().then((result) => {
        //console.log(result.success);
        if (result.success === true) {
          this.setState({ successShow: true });
          this.setState({ errorMessage: result.message });
          this.setState({ bgColor: "alert alert-success alert-dismissible" });
          setTimeout(function () {
            window.location.reload();
          }, 2000);
        } else {
          this.setState({ successMessage: true });
          this.setState({ errorMessage: result.message });
          this.setState({ bgColor: "alert alert-danger alert-dismissible" });
        }
      });
    });
  }

  channelHandler(e) {
    // console.log(e.target.value);
    this.setState({
      channel: e.target.value,
    });
    // this.getCampaignList(e.target.value);
    this.setState({ campaignList: [] })
  }

  channelHandlerFilterSearch = (e) => {
    this.setState({
      channel: e.target.value,
    });
    this.searchByNumber(e.target.value)
    this.setState({ campaignList: [] })
  }

  // channelHandlerFilterSearch(e) {
  //   // console.log(e.target.value);
  //   this.setState({
  //     channel: e.target.value,
  //   });
  //   // this.searchByNumber();
  // }

  startDateHandler = (date) => {
    this.setState({
      startDate: date,
      // endDate: date,
    });
  };
  endDateHandler = (date) => {
    this.setState({
      endDate: date,
    });
  };

  startDateTemplateHandler = (date) => {
    // Calculate one month ahead from selected start date
    const maxToDate = new Date(date);
    maxToDate.setMonth(maxToDate.getMonth() + 1); // Add one month

    this.setState({
      startDateTemplate: date,
      endDateTemplate: null, // Reset end date if new start date is selected
      maxDate: maxToDate,
    });
  };

  endDateTemplateHandler = (date) => {
    this.setState({
      endDateTemplate: date,
    });
  };

  startDateDaywiseHandler = (date) => {
    // Calculate max date = one month after selected date
    const maxToDate = new Date(date);
    maxToDate.setMonth(maxToDate.getMonth() + 1);

    this.setState({
      startDatedaywise: date,
      endDatedaywise: null, // reset end date when start changes
      maxDate: maxToDate,
    });
  };

  endDateDaywiseHandler = (date) => {
    this.setState({
      endDatedaywise: date,
    });
  };

  CampaignData = (data) => {
    let totalOptOut = 0;
    let totalDND = 0;
    let totalCost = 0;


    data.forEach((x) => {
      // console.log(x.template_id.substr(-4, 4));

      totalOptOut += x.optout || 0;
      totalDND += x.dnd || 0;
      totalCost += parseFloat(x.campaign_cost) || 0;
    });

    totalCost = totalCost.toFixed(2);

    this.setState({
      totalCost: totalCost,
      totalDND: totalDND,
      totalOptOut: totalOptOut
    })
  }

  TemplateListDetails = async (templateid) => {
    // Open the popup when starting to fetch template details
    this.setState({ openTemplatePopup: true });

    const data = {
      token: this.state.token,
      user_id: this.state.user_id,
      id: templateid,
      method: "retrieveid",
    };

    try {
      let response = await fetch(`${HOST_URL}/whatsapp_template.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      let result = await response.json();

      if (result.success) {
        // Successfully fetched template details
        this.setState({
          templateDetails: result.data, // Update the template details state
          // openTemplatePopup: true, // Ensure the popup is still open
        });
      } else {
        // Handle failure case (optional: you could reset or handle the error)
        this.setState({
          templateDetails: null, // Optional: reset template details on failure
          // openTemplatePopup: false, // Close the popup if fetching failed
        });
      }
    } catch (error) {
      // Handle any network or unexpected errors
      console.log(error);
      this.setState({
        templateDetails: null, // Optional: reset template details on error
        // openTemplatePopup: false, // Close the popup in case of an error
      });
    }
  }

  formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  showWhatsappDeletePopup = (id, name, campaignType) => {
    this.setState({ deleteWhatsappPopup: true, deleteWhatsappId: id, deleteWhatsappCampaignName: name, campaignType: campaignType })
  }

  showSmsDeletePopup = (id, name, campaignType) => {
    this.setState({ deleteWhatsappPopup: true, deleteSmsId: id, deleteSmsCampaignName: name, campaignType: campaignType })
  }

  DeletecampaignList = async () => {
    this.setState({ loading: true })
    let data = {
      token: this.state.token,
      user_id: this.state.user_id,
      campaign_id: this.state.deleteWhatsappId,
      method: "schedule_delete",
    }
    try {
      let response = await fetch(`${NODE_HOST_URL}/whatsapp_campaign`, {
        method: "Post",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify(data)
      })
      let result = await response.json();
      if (result.success) {
        this.setState({ deleteWhatsappPopup: false })
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
    } catch (error) {
      console.log(error);
    }
    this.setState({ loading: false })
  }

  DeleteSmsCampaignList = async () => {
    this.setState({ loading: true })
    let data = {
      token: this.state.token,
      user_id: this.state.user_id,
      campaign_id: this.state.deleteSmsId,
      method: "delete_campaign",
    }
    try {
      let response = await fetch(`${NODE_HOST_URL}/sms`, {
        method: "Post",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify(data)
      })
      let result = await response.json();
      if (result.success) {
        this.setState({ deleteWhatsappPopup: false })
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
    } catch (error) {
      console.log(error);
    }
    this.setState({ loading: false })
  }

  DeleteSmsList = async () => {

  }

  showDeletePopup = (id, name) => {
    this.setState({ deletePopup: true, deleteId: id, deleteCampaignName: name })
  }


  Deletecampaign = async () => {
    const paramDeletedata = {
      token: this.state.token,
      user_id: this.state.user_id,
      campaign_id: this.state.deleteId,
      method: "delete",
    }
    try {
      let { data } = await Axios.post(`${NODE_HOST_URL}/rcs_campaign`, paramDeletedata);
      if (data.success) {
        this.setState({ deletePopup: false });
        const deletedList = this.state.campaignList.filter(x => x._id !== this.state.deleteId);
        this.setState({ campaignList: deletedList });
      }
    } catch (error) {
      console.log(error)
    }
  }

  showPopup = (id, name, date) => {
    this.setState({ openReschedulePopup: true, rescheduleid: id, rescheduleName: name, selectedDate: date });
  }

  rescheduleCampaign = async () => {
    let paramData = {
      user_id: this.state.user_id,
      token: this.state.token,
      method: "reschedule",
      campaign_id: this.state.rescheduleid,
      schedule_datetime: this.state.selectedDate
    }
    try {
      let { data } = await Axios.post(`${NODE_HOST_URL}/rcs_campaign`, paramData);
      if (data.success) {
        this.setState({ openReschedulePopup: false });
        this.getCampaignList();
      }
    } catch (error) {
      console.log(error);
    }
  }

  DayWiseSummaryReportWhatsapp = async () => {
    if (this.state.daywiseChannel === "" || this.state.daywiseChannel === null) {
      this.setState({
        successDaywiseShow: true,
        successdaywiseMessage: "Please Select Channel",
        bgColorDaywise: "alert alert-danger"
      });
      return false
    }
    this.setState({ loading: true })
    let paramData = {
      user_id: this.state.user_id,
      method: "daywise_summary_report",
      token: this.state.token,
      channel: this.state.daywiseChannel,
      date_from: this.currentDate(this.state.startDatedaywise),
      date_to: this.currentDate(this.state.endDatedaywise)
    }
    let { data } = await Axios.post(`${HOST_URL}/bulk_campaign_sms.php`, paramData)
    if (data.success) {
      let summaryData = data.data
      let totalDaywiseData = 0
      let totalDaywiseDeliver = 0
      let totalDaywiseFailed = 0
      let totalDaywiseSent = 0
      let totalDaywiseRead = 0
      let totalDaywiseOptout = 0
      let totalDaywiseOther = 0
      this.setState({ daywiseSummaryList: data.data })

      Object.keys(summaryData).map((x) => {
        let data = summaryData[x]
        totalDaywiseData += (parseInt(data.delivered) + parseInt(data.fail_count) + parseInt(data.sent_count) + parseInt(data.readcount) + parseInt(data.optout_count) + parseInt(data.other_count))
        totalDaywiseDeliver += parseInt(data.delivered)
        totalDaywiseFailed += parseInt(data.fail_count)
        totalDaywiseSent += parseInt(data.sent_count)
        totalDaywiseRead += parseInt(data.readcount)
        totalDaywiseOptout += parseInt(data.optout_count)
        totalDaywiseOther += parseInt(data.other_count)
      })

      this.setState({
        totalDaywiseData: totalDaywiseData,
        totalDaywiseDeliver: totalDaywiseDeliver,
        totalDaywiseFailed: totalDaywiseFailed,
        totalDaywiseSent: totalDaywiseSent,
        totalDaywiseRead: totalDaywiseRead,
        totalDaywiseOptout: totalDaywiseOptout,
        totalDaywiseOther: totalDaywiseOther
      })
      this.setState({ loading: false })
    }
    else {
      this.setState({
        successDaywiseShow: true,
        successdaywiseMessage: data.data,
        bgColorDaywise: "alert alert-danger"
      })
      this.setState({ loading: false })
    }
  }

  DayWiseSummaryReportSms = async () => {
    if (this.state.daywiseChannel === "" || this.state.daywiseChannel === null) {
      this.setState({
        successDaywiseShow: true,
        successdaywiseMessage: "Please Select Channel",
        bgColorDaywise: "alert alert-danger"
      });
      return false
    }
    this.setState({ loading: true })
    let paramData = {
      user_id: this.state.user_id,
      method: "daywise_summary_report",
      token: this.state.token,
      channel: this.state.daywiseChannel,
      from_date: this.currentDate(this.state.startDatedaywise),
      to_date: this.currentDate(this.state.endDatedaywise)
    }
    let { data } = await Axios.post(`${HOST_URL_DB2}/bulk_campaign_sms.php`, paramData)
    if (data.success) {
      let summaryData = data.data
      let totalDaywiseData = 0
      let totalDaywiseDeliver = 0
      let totalDaywiseFailed = 0
      let totalDaywiseDnd = 0
      let totalDaywiseOther = 0
      this.setState({ daywiseSummaryList: data.data })

      Object.keys(summaryData).map((x) => {
        let data = summaryData[x]
        totalDaywiseData += (parseInt(data.delivered) + parseInt(data.fail_count) + parseInt(data.dnd_count) + parseInt(data.other_count))
        totalDaywiseDeliver += parseInt(data.delivered)
        totalDaywiseFailed += parseInt(data.fail_count)
        totalDaywiseDnd += parseInt(data.dnd_count)
        totalDaywiseOther += parseInt(data.other_count)
      })

      this.setState({
        totalDaywiseData: totalDaywiseData,
        totalDaywiseDeliver: totalDaywiseDeliver,
        totalDaywiseFailed: totalDaywiseFailed,
        totalDaywiseDnd: totalDaywiseDnd,
        totalDaywiseOther: totalDaywiseOther
      })
      this.setState({ loading: false })
    }
    else {
      this.setState({
        successDaywiseShow: true,
        successdaywiseMessage: data.data,
        bgColorDaywise: "alert alert-danger"
      })
      this.setState({ loading: false })
    }
  }

  //  filterDate = (date) => {
  //   const currentDate = new Date();
  //   const previousMonth = startOfMonth(addMonths(currentDate, -1)); // Start of last month
  //   const twoMonthsLater = endOfMonth(addMonths(currentDate, 2));
  //   // Disable dates that are in the previous month or outside the two months after the current date
  //   return isAfter(date, previousMonth) && isBefore(date, twoMonthsLater);
  // };

  getMaxDate() {
    const selectedDate = new Date(this.state.selectedDate);
    selectedDate.setMonth(selectedDate.getMonth() + 2); // Add 2 months
    const year = selectedDate.getFullYear();
    const month = (selectedDate.getMonth() + 1).toString().padStart(2, '0');
    const day = selectedDate.getDate().toString().padStart(2, '0');
    const hours = selectedDate.getHours().toString().padStart(2, '0');
    const minutes = selectedDate.getMinutes().toString().padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  handleChange = (e) => {
    this.setState({ selectedDate: e.target.value });
  }

  searchByNumber = async () => {
    this.setState({ loading: true })
    if (this.state.channel !== "all") {
      let paramData = {
        method: "number_search_whatsapp",
        fromdate: this.currentDate(this.state.startDate),
        todate: this.currentDate(this.state.endDate),
        user_id: this.state.user_id,
        token: this.state.token,
        mobile_number: this.state.search
      }
      try {
        this.setState({ loadingBtn: true, loadingBtn: true })
        let { data } = await Axios.post(`${NODE_HOST_URL}/whatsapp_report`, paramData);
        if (data.success) {
          if (this.state.channel === "whatsapp") {
            const mergedArray = data.data.whatsapp.bulk.concat(data.data.whatsapp.report);
            this.setState({ numberFiltercampaignList: mergedArray })
          }
          else if (this.state.channel === "sms") {
            this.setState({ numberFiltercampaignList: data.data.sms })
          }
          else if (this.state.channel === "rcs") {
            this.setState({ numberFiltercampaignList: data.data.rcs })
          }
          else {
            this.setState({ numberFiltercampaignList: [] })
          }
          // this.setState({ numberFiltercampaignListWhatsapp: data.data.whatsapp , numberFiltercampaignListSms:data.data.sms , numberFiltercampaignListRcs: data.data.rcs});
        }
      } catch (error) {
        console.log(error)
      }
    }
    this.setState({ loading: false, loadingBtn: false })
  }

  handleTemplateChannelChange = (e) => {
    this.setState({ templateChannel: e.target.value, templateSummaryList: {}, successTemplateShow: false });

  }

  handleDayWiseChannelChange = (e) => {
    this.setState({ daywiseChannel: e.target.value, daywiseSummaryList: {}, successDaywiseShow: false });

  }

  searchTemplateSummary = async () => {
    if (this.state.templateChannel === "" || this.state.templateChannel === null) {
      this.setState({
        successTemplateShow: true,
        successTemplateMessage: "Please Select Channel",
        bgColorTemplate: "alert alert-danger",
      });
      return false
    }

    this.setState({ loading: true })
    let paramData = {
      method: "template_summary_report",
      date_from: this.currentDate(this.state.startDateTemplate),
      date_to: this.currentDate(this.state.endDateTemplate),
      user_id: this.state.user_id,
      token: this.state.token,
      channel: "whatsapp"
    }
    try {
      this.setState({ loadingBtn: true, loadingBtn: true })
      let { data } = await Axios.post(`${HOST_URL}/bulk_campaign_sms.php`, paramData);
      if (data.success) {
        let dataListWhatsapp = data.data
        let totalWhatsapp = 0
        let deliveredWhatsapp = 0
        let failedWhatsapp = 0
        let sentWhatsapp = 0
        let readWhatsapp = 0
        let optoutWhatsapp = 0
        let otherWhatsapp = 0
        this.setState({ templateSummaryList: data.data });

        Object.keys(dataListWhatsapp).map((x) => {
          totalWhatsapp += (parseInt(dataListWhatsapp[x].delivered) + parseInt(dataListWhatsapp[x].fail_count) + parseInt(dataListWhatsapp[x].sent_count) + parseInt(dataListWhatsapp[x].readcount) + parseInt(dataListWhatsapp[x].optout_count) + parseInt(dataListWhatsapp[x].other_count))
          deliveredWhatsapp += parseInt(dataListWhatsapp[x].delivered)
          failedWhatsapp += parseInt(dataListWhatsapp[x].fail_count)
          sentWhatsapp += parseInt(dataListWhatsapp[x].sent_count)
          readWhatsapp += parseInt(dataListWhatsapp[x].readcount)
          optoutWhatsapp += parseInt(dataListWhatsapp[x].optout_count)
          otherWhatsapp += parseInt(dataListWhatsapp[x].other_count)
        });

        this.setState({
          totalWhatsapp: totalWhatsapp,
          deliveredWhatsapp: deliveredWhatsapp,
          failedWhatsapp: failedWhatsapp,
          sentWhatsapp: sentWhatsapp,
          readWhatsapp: readWhatsapp,
          optoutWhatsapp: optoutWhatsapp,
          otherWhatsapp: otherWhatsapp
        });


      }
      else {

      }
    } catch (error) {
      console.log(error)
    }

    this.setState({ loading: false, loadingBtn: false })
  }

  searchTemplateSummarySms = async () => {
    if (this.state.templateChannel === "" || this.state.templateChannel === null) {
      this.setState({
        successTemplateShow: true,
        successTemplateMessage: "Please Select Channel",
        bgColorTemplate: "alert alert-danger",
      });
      return false
    }

    this.setState({ loading: true })
    let paramData = {
      method: "template_summary_report",
      from_date: this.currentDate(this.state.startDateTemplate),
      to_date: this.currentDate(this.state.endDateTemplate),
      user_id: this.state.user_id,
      token: this.state.token,
      channel: "sms"
    }
    try {
      this.setState({ loadingBtn: true, loadingBtn: true })
      let { data } = await Axios.post(`${HOST_URL_DB2}/bulk_campaign_sms.php`, paramData);
      if (data.success) {
        let dataListSms = data.data
        let totalSms = 0
        let deliveredSms = 0
        let failedSms = 0
        let dndSms = 0
        let otherSms = 0
        this.setState({ templateSummaryList: data.data })

        Object.keys(dataListSms).map((x) => {
          totalSms += (parseInt(dataListSms[x].delivered) + parseInt(dataListSms[x].fail_count) + parseInt(dataListSms[x].dnd_count) + parseInt(dataListSms[x].other_count))
          deliveredSms += parseInt(dataListSms[x].delivered)
          failedSms += parseInt(dataListSms[x].fail_count)
          dndSms += parseInt(dataListSms[x].dnd_count)
          otherSms += parseInt(dataListSms[x].other_count)
        });

        this.setState({
          totalSms: totalSms,
          deliveredSms: deliveredSms,
          failedSms: failedSms,
          dndSms: dndSms,
          otherSms: otherSms
        });
      }
    } catch (error) {
      console.log(error)
    }

    this.setState({ loading: false, loadingBtn: false })

  }

  closePopup = () => {
    this.setState({ openTemplatePopup: false })
  }

  exportToExcel = () => {

    let exportData = null

    if (this.state.channel === "whatsapp") {
      exportData = this.state.campaignList.map((item) => ({
        CampaignName: item.campaign_name,
        CampaignID: item.id,
        TemplateID: item.template_id,
        Total: item.contact_count,
        Delivered: item.delivered,
        Failed: item.failed,
        Sent: item.sent,
        Read: item.read,
        OptOut: item.optout,
      }));
    } else if (this.state.channel === "sms") {
      exportData = this.state.campaignList.map((item) => ({
        CampaignName: item.campaign_name,
        CampaignID: item.id,
        Total: item.contact_count,
        Delivered: item.delivered,
        Failed: item.failed,
        OptOut: item.optout,
        Other: item.other,
        DND: item.dnd,
      }));
    } else if (this.state.channel === "rcs") {
      exportData = this.state.campaignList.map((item) => ({
        CampaignName: item.campaign_name,
        CampaignID: item._id,
        Total: item.contact_count,
        Delivered: item.deliver_count,
        Failed: item.fail_count,
        Sent: item.sent_count,
        Read: item.read_count,
      }));
    }
    else {
      exportData = null
    }

    const worksheet = XLSX.utils.json_to_sheet(exportData);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, this.state.channel === "whatsapp" ? "WpCampaignSummary" : this.state.channel === "sms" ? "SmsCampaignSummary" : this.state.channel === "rcs" ? "RcsCampaignSummary" : "CampaignReport");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const fileData = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });

    saveAs(fileData, this.state.channel === "whatsapp" ? "WpCampaignSummary.xlsx" : this.state.channel === "sms" ? "SmsCampaignSummary.xlsx" : this.state.channel === "rcs" ? "RcsCampaignSummary.xlsx" : "CampaignReport.xlsx");
  };

  goToScheduleReport = () => {
    this.setState({ scheduleReport: true, campaignReport: false, numberFilterSearch: false })
    this.props.history.push('/dashboard/schedule-report');
  }

  getPieStyle(delivered, failed, other) {
    const total = delivered + failed + other;

    if (total === 0) {
      return {
        width: "130px",
        height: "130px",
        borderRadius: "50%",
        border: "22px solid #e0e0e0",
        marginRight: "5px"
      };
    }

    const deliveredDeg = (delivered / total) * 360;
    const failedDeg = (failed / total) * 360;

    // rotation starts from middle of delivered segment
    const rotation = -(deliveredDeg / 2);

    return {
      width: "130px",
      height: "130px",
      borderRadius: "50%",
      border: "22px solid #ff9800",  // base → Other color
      borderTopColor: "#4caf50",      // Delivered
      borderRightColor: "#f44336",    // Failed
      transform: `rotate(${rotation}deg)`,
      marginRight: "5px"
    };
  }

  handleRcsDownload = async (item) => {
    try {
      // Set loading state
      this.setState(prevState => ({
        downloadingCampaigns: {
          ...prevState.downloadingCampaigns,
          [item._id]: true
        }
      }));

      const payload = {
        user_id: this.state.user_id,
        token: this.state.token,
        method: "campaign_report_download",
        campaign_id: item._id,
        fromdate: this.currentDate(this.state.startDate),
        todate: this.currentDate(this.state.endDate)
      };

      const response = await Axios.post(
        `${NODE_HOST_URL_v1}/rcs`,
        payload,
        { responseType: item.archive_status === 0 ? "blob" : "json" }
      );

      let csvBuffer;

      if (item.archive_status === 1) {
        const fileUrl = response.data.download_url;
        if (!fileUrl) {
          throw new Error("Download URL not received");
        }
        const fileResponse = await fetch(fileUrl);
        const gzipBuffer = await fileResponse.arrayBuffer();
        csvBuffer = pako.inflate(new Uint8Array(gzipBuffer));
      } else {
        const blob = response.data instanceof Blob
          ? response.data
          : new Blob([response.data], { type: "text/csv" });
        csvBuffer = await blob.arrayBuffer();
      }

      const zip = new JSZip();
      zip.file(`rcs_campaign_${item._id}.csv`, csvBuffer);
      const zipBlob = await zip.generateAsync({ type: "blob" });

      const blobUrl = URL.createObjectURL(zipBlob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", `rcs_campaign_${item._id}.zip`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(blobUrl);

      this.setState(prevState => {
        const newDownloading = { ...prevState.downloadingCampaigns };
        delete newDownloading[item._id];
        return { downloadingCampaigns: newDownloading };
      });
    } catch (error) {
      console.error("RCS download failed:", error);
      // Remove loading state on error
      this.setState(prevState => {
        const newDownloading = { ...prevState.downloadingCampaigns };
        delete newDownloading[item._id];
        return { downloadingCampaigns: newDownloading };
      });
    }
  };

  handleSmsDownload = (item) => {
    try {
      // Set loading state
      this.setState(prevState => ({
        downloadingCampaigns: {
          ...prevState.downloadingCampaigns,
          [item.id]: true
        }
      }));

      const downloadUrl = `${HOST_URL_DB2}/bulk_campaign_sms.php?user_id=${item.user_id}&method=download&token=${item.user_token}&channel=sms&campaign_id=${item.id}&archive_status=${item.archive_status}&camp_start_datetime=${item.camp_start_datetime}`;
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = `sms_campaign_${item.id}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Remove loading state after a small delay to ensure download starts
      setTimeout(() => {
        this.setState(prevState => {
          const newDownloading = { ...prevState.downloadingCampaigns };
          delete newDownloading[item.id];
          return { downloadingCampaigns: newDownloading };
        });
      }, 1000);
    } catch (error) {
      console.error("SMS download failed:", error);
      // Remove loading state on error
      this.setState(prevState => {
        const newDownloading = { ...prevState.downloadingCampaigns };
        delete newDownloading[item.id];
        return { downloadingCampaigns: newDownloading };
      });
    }
  };

  handleWhatsappDownload = (item) => {
    try {
      // Set loading state
      this.setState(prevState => ({
        downloadingCampaigns: {
          ...prevState.downloadingCampaigns,
          [item.id]: true
        }
      }));

      const downloadUrl = `${HOST_URL}/bulk_campaign.php?user_id=${item.user_id}&method=download&campaign_id=${item.id}&channel=whatsapp&token=${item.user_token}`;
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = `whatsapp_campaign_${item.id}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Remove loading state after a small delay to ensure download starts
      setTimeout(() => {
        this.setState(prevState => {
          const newDownloading = { ...prevState.downloadingCampaigns };
          delete newDownloading[item.id];
          return { downloadingCampaigns: newDownloading };
        });
      }, 1000);
    } catch (error) {
      console.error("WhatsApp download failed:", error);
      // Remove loading state on error
      this.setState(prevState => {
        const newDownloading = { ...prevState.downloadingCampaigns };
        delete newDownloading[item.id];
        return { downloadingCampaigns: newDownloading };
      });
    }
  };

  Openpopup = (id, contact_count, delivered, failed, sent, read, optout, other) => {
    this.setState(
      {
        insight_template_id: id,
        activeIndex: 1,
        InsightTotal: contact_count,
        InsightDelivered: delivered,
        InsightFailed: failed,
        InsightSent: sent,
        InsightRead: read,
        InsightOptout: optout,
        InsightOther: other  // optional: popup open hote hi page 1
      },
      () => {
        this.InsightFinalData(); // ✅ state set hone ke baad call
      }
    );
  };

  OpenContactCountpopup = (items) => {
    this.setState({ contactCountPopup: true, contactCountSummary: items });
    // console.log(items.number_count);
  }

  // InsightDataSummary = async () => {
  //   this.setState({ loading: true })
  //   try {

  //     const paramData = {
  //       method: "TemplateList",
  //       filter: {

  //       },
  //       page: 1,
  //       user_id: this.state.user_id,
  //       // token: this.state.token
  //     }

  //     const { data } = await Axios.post(
  //       `${NODE_HOST_URL_v1}/whatsapp`,
  //       paramData,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${this.state.token}`,
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     if (data.success) {
  //       // console.log(data.data);
  //       let filterData = data.data.filter(x => x.id === this.state.insight_template_id)
  //       // console.log(filterData);
  //       // this.setState({ facebook_tempid: filterData[0].facebook_tempid })
  //       this.InsightFinalData(filterData[0].facebook_tempid)


  //       // this.setState({ insightDataSummary: data.data });
  //     }

  //   } catch (error) {
  //     console.error("InsightDataSummary error:", error);
  //   }
  // };

  InsightFinalData = async () => {
    // this.setState({ insightLoading: true })
    this.setState({ openInsightPopup: true });
    let paramData = {
      method: "btnReportSummary",
      // fromDate: this.currentDate(this.state.startDate),
      // toDate: this.currentDate(this.state.endDate),
      user_id: this.state.user_id,
      token: this.state.token,
      camp_id: this.state.insight_template_id,
      // TempList: [
      //   parseInt(facebookId)
      // ]
    }
    let { data } = await Axios.post(`${NODE_HOST_URL_v1}/BtnReports`, paramData)
    if (data.success) {
      console.log(data);
      this.setState({ insightDataSummary: data.data });

      // const firstEntry = data.data?.data?.[0];
      // this.setState({
      //   insightDataSummary: firstEntry?.data_points ?? [],
      //   nextPageUrl: data.data?.paging?.next ?? "",
      //   // insightLoading: false,
      //   loading: false
      // });
    }
    else {
      this.setState({ loading: false })
    }
  }



  InsightDataDetails = async (btn_name, page = 1) => {
    this.setState({
      InsightDetailsShow: true,
      insightDetailsLoading: true,
      insightDataDetails: [],
      activeInsightBtnName: btn_name,
      detailCurrentPage: page,
      detailSearchQuery: ""
    });
    const paramData = {
      user_id: this.state.user_id,
      method: "btnReportDetail",
      token: this.state.token,
      camp_id: this.state.insight_template_id,
      btn_name: btn_name,
      page: page
    };
    try {
      const { data } = await Axios.post(
        `${NODE_HOST_URL_v1}/BtnReports`,
        paramData,
        {
          headers: {
            Authorization: `Bearer ${this.state.token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (data.success) {
        const raw = data.data;
        const totalRecords = data.total ?? data.totalRecords ?? data.count ?? raw?.total ?? raw?.totalRecords ?? 0;
        const perPage = data.perPage ?? data.per_page ?? data.limit ?? raw?.perPage ?? raw?.per_page ?? 10;
        const totalPages = data.totalPages ?? data.total_pages ?? raw?.totalPages ?? raw?.total_pages ?? (totalRecords > 0 ? Math.ceil(totalRecords / perPage) : 1);
        this.setState({
          insightDataDetails: raw ?? [],
          insightDetailsLoading: false,
          detailTotalPages: Math.max(1, totalPages),
          detailTotalRecords: totalRecords
        });
      } else {
        this.setState({ insightDetailsLoading: false });
      }
    } catch (error) {
      console.error("InsightDataDetails error:", error);
      this.setState({ insightDetailsLoading: false });
    }
  };

  handleDetailPageChange = (page) => {
    if (page < 1) return;
    if (this.state.detailTotalPages > 1 && page > this.state.detailTotalPages) return;
    this.InsightDataDetails(this.state.activeInsightBtnName, page);
  };

  downloadDetailData = () => {
    const { insightDataDetails, activeInsightBtnName } = this.state;
    const btnRows = Array.isArray(insightDataDetails?.btn_detail) ? insightDataDetails.btn_detail : [];
    const ctaRows = Array.isArray(insightDataDetails?.cta_detail) ? insightDataDetails.cta_detail : [];
    const allRows = [...btnRows.map(r => ({ Mobile: r.mobile, "Click Count": r.click_count, Type: r.btn_name, "Created Date": r.createdAt ?? "-" })),
                     ...ctaRows.map(r => ({ Mobile: r.phone_number, "Click Count": r.url_clickcount, Type: "CTA", "Created Date": r.created ?? "-" }))];
    if (!allRows.length) return;
    const headers = Object.keys(allRows[0]).join(",");
    const rows = allRows.map(r => Object.values(r).map(v => `"${String(v ?? "").replace(/"/g, '""')}"`).join(",")).join("\n");
    const blob = new Blob([`${headers}\n${rows}`], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, `btn_detail_${activeInsightBtnName}_page${this.state.detailCurrentPage}.csv`);
  };

  openClickReportModal = () => {
    this.setState({ clickReportModal: true }, () => {
      this.fetchClickReportSummary(1);
    });
  };

  closeClickReportModal = () => {
    this.setState({
      clickReportModal: false,
      clickReportSummary: [],
      clickReportPage: 1,
      clickReportTotalPages: 1,
      clickReportTotalCount: 0
    });
  };

  fetchClickReportSummary = async (page = 1) => {
    this.setState({ clickReportLoading: true, clickReportPage: page });
    const paramData = {
      user_id: this.state.user_id,
      token: this.state.token,
      method: "rcs_click_report_summary",
      fromDate: this.currentDate(this.state.startDate),
      toDate: this.currentDate(this.state.endDate),
      channel: "rcs",
      page
    };
    try {
      const { data } = await Axios.post(
        `${NODE_HOST_URL_v1}/click_report_summary`,
        paramData,
        {
          headers: {
            Authorization: `Bearer ${this.state.token}`,
            "Content-Type": "application/json"
          }
        }
      );
      if (data.success) {
        this.setState({
          clickReportSummary: data.data ?? [],
          clickReportTotalPages: Math.max(1, data.totalPages ?? 1),
          clickReportTotalCount: data.totalCount ?? 0,
          clickReportLoading: false
        });
      } else {
        this.setState({ clickReportLoading: false });
      }
    } catch (error) {
      console.error("fetchClickReportSummary error:", error);
      this.setState({ clickReportLoading: false });
    }
  };

  handleClickReportPageChange = (page) => {
    if (page < 1) return;
    if (this.state.clickReportTotalPages > 1 && page > this.state.clickReportTotalPages) return;
    this.fetchClickReportSummary(page);
  };

  downloadClickReportDetail = async (templateId) => {
    this.setState(prevState => ({
      clickReportDownloading: { ...prevState.clickReportDownloading, [templateId]: true }
    }));
    try {
      const response = await Axios.post(
        `${NODE_HOST_URL_v1}/click_report_summary`,
        {
          user_id: this.state.user_id,
          token: this.state.token,
          method: "download_rcs_detail",
          fromDate: this.currentDate(this.state.startDate),
          toDate: this.currentDate(this.state.endDate),
          channel: "rcs",
          templateId
        },
        {
          headers: {
            Authorization: `Bearer ${this.state.token}`,
            "Content-Type": "application/json"
          },
          responseType: "blob"
        }
      );
      const blob = response.data instanceof Blob ? response.data : new Blob([response.data], { type: "text/csv" });
      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", `rcs_click_report_${templateId}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("downloadClickReportDetail error:", error);
    } finally {
      this.setState(prevState => {
        const newDownloading = { ...prevState.clickReportDownloading };
        delete newDownloading[templateId];
        return { clickReportDownloading: newDownloading };
      });
    }
  };

  handlePageForward = () => {
    this.setState(
      prevState => ({
        activeIndex: prevState.activeIndex + 1
      }),
      () => {
        this.InsightsDataReport(); // 👈 updated page goes to API
      }
    );
  };


  handlePageBackward = () => {
    if (this.state.activeIndex > 1) {
      this.setState(
        prevState => ({
          activeIndex: prevState.activeIndex - 1
        }),
        () => {
          this.InsightsDataReport();
        }
      );
    }
  };

  toggleAccordion = async (rcscampaignId, campaignId, fallbackKey, channel) => {
    // console.log(rcscampaignId,campaignId, fallbackKey, channel);

    const accordionKey = `${campaignId || rcscampaignId}-${fallbackKey}`;

    const { openAccordion = [], listData = [] } = this.state;

    // 🔹 Check current state FIRST
    const isAlreadyOpen = openAccordion.includes(accordionKey);

    // 🔹 Toggle UI
    this.setState(prevState => ({
      openAccordion: isAlreadyOpen
        ? prevState.openAccordion.filter(key => key !== accordionKey)
        : [...prevState.openAccordion, accordionKey]
    }));

    // 🔹 If closing → STOP API call
    if (isAlreadyOpen) return;

    // console.log(campaignId);


    const paramData = {
      user_id: this.state.user_id,
      token: this.state.token,
      method: "retrieve_new_refid",
      ref_id: campaignId || rcscampaignId,
      channel
    };

    try {
      const { data } = await Axios.post(
        `${HOST_URL_DB2}/bulk_campaign_sms.php`,
        paramData
      );

      if (!data?.success || !Array.isArray(data.data)) return;

      const campaignData = data.data[0];

      this.setState(prevState => ({
        campaignList: Array.isArray(prevState.campaignList)
          ? prevState.campaignList.map(campaign => {
            if ((campaign._id !== rcscampaignId) || (campaign.id !== campaignId)) return campaign;

            const updatedFallback = {
              ...(campaign.fallback_condition || {})
            };

            const fb = updatedFallback[fallbackKey];

            if (fb && fb.channel === campaignData.campaign_type) {
              updatedFallback[fallbackKey] = {
                ...fb,
                FallbackData: campaignData
              };
            }

            return {
              ...campaign,
              fallback_condition: updatedFallback
            };
          })
          : [] // ✅ fallback safety
      }));
    } catch (error) {
      console.error("toggleAccordion error:", error);
    }
  };

  FetchEnableDownload = async () => {
    try {
      let paramData = {
        method: "FetchEnabled",
        user_id: this.state.user_id
      };

      let { data } = await Axios.post(
        `${NODE_HOST_URL_v1}/EncryptDownload`,
        paramData,
        {
          headers: {
            Authorization: `Bearer ${this.state.token}`,
            "Content-Type": "application/json"
          }
        }
      );

      if (data.success) {
        // console.log(data);
        this.setState({ encryptData: data.data[0] })
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  handleNextPage = async () => {
    this.setState({ insightLoading: true })
    try {
      const url = this.state.nextPageUrl;
      const accessToken = "EABFalxmwxMkBAKPaaVqUHZABaCldGzuIUFOFEQDjoMqJDJFSZCctsq57ky2p29ma7CMZCd7vWZBFVAfXUnIOYhKkUc66RtTQpsREj6EEmKyLNwvMHZANAvDcbKsUOs3uHTiLrecZCbUdpU6cVQZCvQ3SYrDO5aouwcUZCyNJQU0JAQrQaPy3VlYU2wKxfNdGEbiGVimS2IIYoAZDZD"

      if (!url) return;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json"
        }
      });

      const data = await response.json();

      // console.log(data);

      this.setState({ insightDataSummary: data.data[0].data_points })
      this.setState({ nextPageUrl: data.paging.next })
      this.setState({ previousPageUrl: data.paging.previous })
      this.setState({ insightLoading: false })

    } catch (error) {
      console.error("Pagination error:", error);
      this.setState({ insightLoading: false })
    }
  };

  handlePrevPage = async () => {
    this.setState({ insightLoading: true })
    try {
      const url = this.state.previousPageUrl;
      const accessToken = "EABFalxmwxMkBAKPaaVqUHZABaCldGzuIUFOFEQDjoMqJDJFSZCctsq57ky2p29ma7CMZCd7vWZBFVAfXUnIOYhKkUc66RtTQpsREj6EEmKyLNwvMHZANAvDcbKsUOs3uHTiLrecZCbUdpU6cVQZCvQ3SYrDO5aouwcUZCyNJQU0JAQrQaPy3VlYU2wKxfNdGEbiGVimS2IIYoAZDZD"

      if (!url) return;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json"
        }
      });

      const data = await response.json();

      // console.log(data);

      this.setState({ insightDataSummary: data.data[0].data_points })
      this.setState({ nextPageUrl: data.paging.next })
      this.setState({ previousPageUrl: data.paging.previous })
      this.setState({ insightLoading: false })

    } catch (error) {
      console.error("Pagination error:", error);
      this.setState({ insightLoading: false })
    }
  };

  formatInsightDate = (timestamp) => {
    if (!timestamp) return "";

    const date = new Date(timestamp * 1000);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };





  render() {
    const currentDate = new Date();
    const formattedDate = this.formatDate(currentDate);

    console.log(this.state.insightDataDetails);

    // console.log(this.state.activeIndex);

    // const { insightDataSummary, currentPage, itemsPerPage } = this.state;

    // const filteredData = insightDataSummary.filter((x) => {
    //   return this.state.searchbtnName.toLowerCase() === ""
    //     ? x
    //     : x.btn_name.btn_name
    //       .toLowerCase()
    //       .includes(this.state.searchbtnName.toLowerCase());
    // });

    // const indexOfLastItem = currentPage * itemsPerPage;
    // const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    // const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

    // const totalPages = Math.ceil(filteredData.length / itemsPerPage);

    return (
      <>
        <div className="wrapper">
          <DashboardLeftMenu />
          <div className="main">
            <DashboardHeader />
            {this.state.loading && <Spining />}
            <main className="content">
              <div className="container-fluid p-0">
                <div className="row mb-2 mb-xl-3">
                  <div className="col-auto d-none d-sm-block">
                    {this.state.campaignReport ?
                      <h3>
                        <strong>Campaign </strong> List{" "}
                      </h3> : this.state.numberFilterSearch ?
                        <h3>
                          <strong>Number Filter Search </strong>{" "}
                        </h3> : this.state.templateSummary ?
                          <h3>
                            <strong>Template Summary </strong>{" "}
                          </h3> : null}
                  </div>
                  <div className="col-auto ml-auto text-right mt-n1">
                    <Link
                      className="btn btn-primary btn-sm"
                      to="/dashboard/campaign-start"
                    >
                      {" "}
                      <FontAwesomeIcon icon={faPlus} color="" /> Create New
                      Campaign{" "}
                    </Link>
                  </div>
                </div>

                <div className="row">
                  <div className="col-xl-12 col-xxl-5 d-flex">
                    <div className="w-100">
                      {this.state.numberFilterSearch ? null :
                        <>
                          {this.state.campaignList?.length > 0 &&
                            <>
                              {this.state.channel === "all" ?
                                <div className="row g-3 mb-3 align-items-stretch">
                                  {/* ── WhatsApp Card ── */}
                                  {[
                                    {
                                      key: "wa",
                                      accent: "#16a34a",
                                      iconBg: "#dcfce7",
                                      icon: <IoLogoWhatsapp style={{ color: "#16a34a", fontSize: "20px" }} />,
                                      title: "WhatsApp",
                                      campaigns: this.state.totalWhatsapp || 0,
                                      cost: this.state.whatsappCost || 0,
                                      costColor: "#16a34a",
                                      stats: [
                                        { label: "Submitted", value: this.state.whatsappSubmission || 0, color: "#64748b", bg: "#f8fafc" },
                                        { label: "Delivered",  value: this.state.whatsappDelivered  || 0, color: "#16a34a", bg: "#f0fdf4" },
                                        { label: "Failed",     value: this.state.whatsappFailed     || 0, color: "#ef4444", bg: "#fef2f2" },
                                        { label: "Sent",       value: this.state.whatsappSent       || 0, color: "#d97706", bg: "#fffbeb" },
                                        { label: "Read",       value: this.state.whatsappRead       || 0, color: "#2563eb", bg: "#eff6ff" },
                                        { label: "Opt Out",    value: this.state.whatsappOptout     || 0, color: "#ea580c", bg: "#fff7ed" },
                                        { label: "Other",      value: this.state.whatsappOther      || 0, color: "#94a3b8", bg: "#f8fafc" },
                                      ],
                                      onDetails: () => this.setState({ whatsappFullDetails: true }),
                                    },
                                    {
                                      key: "sms",
                                      accent: "#2563eb",
                                      iconBg: "#dbeafe",
                                      icon: <FaSms style={{ color: "#2563eb", fontSize: "18px" }} />,
                                      title: "SMS",
                                      campaigns: this.state.totalSms || 0,
                                      cost: this.state.smsCost || 0,
                                      costColor: "#2563eb",
                                      stats: [
                                        { label: "Submitted", value: this.state.smsSubmission || 0, color: "#64748b", bg: "#f8fafc" },
                                        { label: "Delivered", value: this.state.smsDelivered  || 0, color: "#16a34a", bg: "#f0fdf4" },
                                        { label: "Failed",    value: this.state.smsFailed     || 0, color: "#ef4444", bg: "#fef2f2" },
                                        { label: "Opt Out",   value: this.state.smsOptOut     || 0, color: "#ea580c", bg: "#fff7ed" },
                                        { label: "DND",       value: this.state.smsDnd        || 0, color: "#7c3aed", bg: "#f5f3ff" },
                                        { label: "Other",     value: this.state.smsOther      || 0, color: "#94a3b8", bg: "#f8fafc" },
                                      ],
                                      onDetails: null,
                                    },
                                    {
                                      key: "rcs",
                                      accent: "#9333ea",
                                      iconBg: "#f3e8ff",
                                      icon: <img alt="RCS" src={RcsImage} style={{ width: "20px", height: "20px" }} />,
                                      title: "RCS",
                                      campaigns: this.state.totalRcs || 0,
                                      cost: this.state.rcsCost || 0,
                                      costColor: "#9333ea",
                                      stats: [
                                        { label: "Submitted", value: this.state.rcsSubmission || 0, color: "#64748b", bg: "#f8fafc" },
                                        { label: "Delivered", value: this.state.rcsDelivered  || 0, color: "#16a34a", bg: "#f0fdf4" },
                                        { label: "Failed",    value: this.state.rcsFailed     || 0, color: "#ef4444", bg: "#fef2f2" },
                                        { label: "Sent",      value: this.state.rcsSent       || 0, color: "#d97706", bg: "#fffbeb" },
                                        { label: "Read",      value: this.state.rcsRead       || 0, color: "#0d9488", bg: "#f0fdfa" },
                                      ],
                                      onDetails: null,
                                    },
                                  ].map((card) => {
                                    console.log(card.cost)
                                    return (
                                    <div className="col-12 col-md-4 d-flex" key={card.key}>
                                      <div style={{ background: "#fff", borderRadius: "14px", border: "1px solid #e2e8f0", boxShadow: "0 2px 8px rgba(0,0,0,0.06)", width: "100%", display: "flex", flexDirection: "column", overflow: "hidden" }}>
                                        {/* Colored top accent bar */}
                                        <div style={{ height: "4px", background: card.accent }} />
                                        {/* Header */}
                                        <div style={{ padding: "14px 18px 12px", borderBottom: "1px solid #f1f5f9", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                            <div style={{ width: "38px", height: "38px", borderRadius: "10px", background: card.iconBg, display: "flex", alignItems: "center", justifyContent: "center" }}>
                                              {card.icon}
                                            </div>
                                            <div>
                                              <div style={{ fontSize: "15px", fontWeight: "700", color: "#1e293b", letterSpacing: "-0.2px" }}>{card.title}</div>
                                              <div style={{ fontSize: "11px", color: "#94a3b8", fontWeight: "500", marginTop: "1px" }}>{card.campaigns} Campaigns</div>
                                            </div>
                                          </div>
                                          <div style={{ textAlign: "right" }}>
                                            <div style={{ fontSize: "10px", fontWeight: "600", color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.5px" }}>Total Cost</div>
                                            <div style={{ fontSize: "17px", fontWeight: "700", color: card.costColor, marginTop: "2px" }}>{card.cost}</div>
                                          </div>
                                        </div>
                                        {/* Stats grid */}
                                        <div style={{ padding: "14px 16px 16px", flex: 1, display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "8px" }}>
                                          {card.stats.map((s, i) => (
                                            <div key={i} style={{ background: s.bg, borderRadius: "8px", padding: "10px 12px" }}>
                                              <div style={{ fontSize: "10px", fontWeight: "600", color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.4px", marginBottom: "4px" }}>{s.label}</div>
                                              <div style={{ fontSize: "20px", fontWeight: "700", color: s.color, lineHeight: 1 }}>{s.value}</div>
                                            </div>
                                          ))}
                                          {card.onDetails && (
                                            <div style={{ background: "#f0f9ff", borderRadius: "8px", padding: "10px 12px", cursor: "pointer", display: "flex", flexDirection: "column", justifyContent: "center" }}
                                              onClick={card.onDetails}>
                                              <div style={{ fontSize: "10px", fontWeight: "600", color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.4px", marginBottom: "4px" }}>Details</div>
                                              <div style={{ fontSize: "12px", fontWeight: "600", color: "#3b82f6" }}>View breakdown →</div>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  )})}
                                </div>
                                :
                                (() => {
                                  const ch = this.state.channel;
                                  const isRcs = ch === "rcs";
                                  const isWa  = ch === "whatsapp";
                                  const isSms = ch === "sms";

                                  const chConfig = isWa
                                    ? { accent: "#16a34a", iconBg: "#dcfce7", icon: <IoLogoWhatsapp style={{ color: "#16a34a", fontSize: "22px" }} />, label: "WhatsApp", campaigns: this.state.totalWhatsapp, cost: this.state.whatsappCost, costColor: "#16a34a" }
                                    : isSms
                                    ? { accent: "#2563eb", iconBg: "#dbeafe",  icon: <FaSms style={{ color: "#2563eb", fontSize: "18px" }} />,              label: "SMS",       campaigns: this.state.totalSms,      cost: this.state.smsCost,      costColor: "#2563eb" }
                                    : { accent: "#9333ea", iconBg: "#f3e8ff",  icon: <img alt="RCS" src={RcsImage} style={{ width: "20px", height: "20px" }} />, label: "RCS", campaigns: this.state.totalRcs, cost: this.state.rcsCost, costColor: "#9333ea" };

                                  const statsItems = [
                                    { label: "Total",     value: isRcs ? this.state.rcscontactcount : (isWa ? (this.state.totalDelivered + this.state.totalFailed + this.state.totalRead + this.state.totalOptOut + this.state.totalSent) : this.state.totalData), color: "#1e293b", bg: "#f8fafc" },
                                    { label: "Delivered", value: isRcs ? this.state.rcsdeliver  : this.state.totalDelivered, color: "#16a34a", bg: "#f0fdf4" },
                                    { label: "Failed",    value: isRcs ? this.state.rcsfailed   : this.state.totalFailed,   color: "#ef4444", bg: "#fef2f2" },
                                    ...(isRcs || isWa ? [{ label: "Sent", value: isRcs ? this.state.rcssent : this.state.totalSent, color: "#d97706", bg: "#fffbeb" }] : []),
                                    ...(isRcs || isWa ? [{ label: "Read", value: isRcs ? (this.state.user_id === 12066 ? (this.state.rcsread + this.state.rcssent) : this.state.rcsread) : this.state.totalRead, color: isRcs ? "#0d9488" : "#2563eb", bg: isRcs ? "#f0fdfa" : "#eff6ff" }] : []),
                                    ...(!isRcs ? [{ label: "Opt Out", value: this.state.totalOptOut, color: "#ea580c", bg: "#fff7ed" }] : []),
                                    ...(isSms ? [{ label: "DND", value: this.state.totalDND, color: "#7c3aed", bg: "#f5f3ff" }] : []),
                                    { label: "Total Cost", value: isRcs ? parseFloat(this.state.totalRcsData || 0).toFixed(2) : parseFloat(this.state.totalCost || 0).toFixed(2), color: chConfig.costColor, bg: "#f8fafc" },
                                  ];

                                  return (
                                    <div style={{ background: "#fff", borderRadius: "14px", border: "1px solid #e2e8f0", boxShadow: "0 2px 8px rgba(0,0,0,0.06)", overflow: "hidden", marginBottom: "20px" }}>
                                      {/* Colored top accent */}
                                      <div style={{ height: "4px", background: chConfig.accent }} />
                                      {/* Header row */}
                                      <div style={{ padding: "14px 20px", borderBottom: "1px solid #f1f5f9", display: "flex", alignItems: "center", gap: "12px" }}>
                                        <div style={{ width: "38px", height: "38px", borderRadius: "10px", background: chConfig.iconBg, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                          {chConfig.icon}
                                        </div>
                                        <div>
                                          <div style={{ fontSize: "15px", fontWeight: "700", color: "#1e293b" }}>{chConfig.label} Summary</div>
                                          <div style={{ fontSize: "11px", color: "#94a3b8", fontWeight: "500" }}>{chConfig.campaigns || 0} Campaigns</div>
                                        </div>
                                        <div style={{ marginLeft: "auto", textAlign: "right" }}>
                                          <div style={{ fontSize: "10px", fontWeight: "600", color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.5px" }}>Total Cost</div>
                                          <div style={{ fontSize: "17px", fontWeight: "700", color: chConfig.costColor }}>{chConfig.cost || 0}</div>
                                        </div>
                                      </div>
                                      {/* Stats row */}
                                      <div style={{ padding: "14px 20px", display: "flex", flexWrap: "wrap", gap: "8px" }}>
                                        {statsItems.map((s, si) => (
                                          <div key={si} style={{ background: s.bg, borderRadius: "8px", padding: "10px 16px", display: "flex", flexDirection: "column", gap: "4px", minWidth: "90px", flex: "1 1 auto" }}>
                                            <div style={{ fontSize: "10px", fontWeight: "600", color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.4px" }}>{s.label}</div>
                                            <div style={{ fontSize: "22px", fontWeight: "700", color: s.color, lineHeight: 1 }}>{s.value || 0}</div>
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  );
                                })()}
                            </>
                          }
                          {(this.state.templateSummaryList && Object.keys(this.state.templateSummaryList).length > 0) &&
                            <div className="row">
                              {this.state.templateChannel === "whatsapp" ?
                                <div className="col-sm-2">
                                  <div className="card">
                                    <div className="card-body p-2">
                                      <h5 className="card-title mb-0" style={{ fontSize: "12px" }}>Total</h5>
                                      <h6 className="mt-0 mb-0">
                                        {this.state.totalWhatsapp}
                                      </h6>
                                    </div>
                                  </div>
                                </div>
                                :
                                <div className="col-sm-2">
                                  <div className="card">
                                    <div className="card-body p-2">
                                      <h5 className="card-title mb-0" style={{ fontSize: "12px" }}>Total</h5>
                                      <h6 className="mt-0 mb-0">
                                        {this?.state?.totalSms}
                                      </h6>
                                    </div>
                                  </div>
                                </div>}
                              <div className="col-sm-2">
                                <div className="card">
                                  <div className="card-body p-2">
                                    <h5 className="card-title mb-0">Delivered</h5>
                                    <h6 className="mt-0 mb-0">
                                      {this.state.templateChannel === "whatsapp" ? this.state.deliveredWhatsapp : this.state.deliveredSms}
                                    </h6>
                                  </div>
                                </div>
                              </div>

                              <div className="col-sm-2">
                                <div className="card">
                                  <div className="card-body p-2">
                                    <h5 className="card-title mb-0">Failed</h5>
                                    <h6 className="mt-0 mb-0">
                                      {this.state.templateChannel === "whatsapp" ? this.state.failedWhatsapp : this.state.failedSms}
                                    </h6>
                                  </div>
                                </div>
                              </div>

                              {this.state.templateChannel === "whatsapp" ?
                                <>
                                  <div className="col-sm-2">
                                    <div className="card">
                                      <div className="card-body p-2">
                                        <h5 className="card-title mb-0">Sent</h5>
                                        <h6 className="mt-0 mb-0">
                                          {this.state.sentWhatsapp}
                                        </h6>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-sm-2">
                                    <div className="card">
                                      <div className="card-body p-2">
                                        <h5 className="card-title mb-0">Read</h5>
                                        <h6 className="mt-0 mb-0">
                                          {this.state.readWhatsapp}
                                        </h6>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-sm-2">
                                    <div className="card">
                                      <div className="card-body p-2">
                                        <h5 className="card-title mb-0">Optout</h5>
                                        <h6 className="mt-0 mb-0">
                                          {this.state.optoutWhatsapp}
                                        </h6>
                                      </div>
                                    </div>
                                  </div>
                                </>
                                :
                                <div className="col-sm-2">
                                  <div className="card">
                                    <div className="card-body p-2">
                                      <h5 className="card-title mb-0">DND</h5>
                                      <h6 className="mt-0 mb-0">
                                        {this.state.dndSms}
                                      </h6>
                                    </div>
                                  </div>
                                </div>
                              }

                              <div className="col-sm-2">
                                <div className="card">
                                  <div className="card-body p-2">
                                    <h5 className="card-title mb-0">Other</h5>
                                    <h6 className="mt-0 mb-0">
                                      {this.state.templateChannel === "whatsapp" ? this.state.otherWhatsapp : this.state.otherSms}
                                    </h6>
                                  </div>
                                </div>
                              </div>

                            </div>
                          }

                          {(this.state.daywiseSummaryList && Object.keys(this.state.daywiseSummaryList).length > 0) &&
                            <div className="row">
                              <div className="col-sm-2">
                                <div className="card">
                                  <div className="card-body p-2">
                                    <h5 className="card-title mb-0" style={{ fontSize: "12px" }}>Total</h5>
                                    <h6 className="mt-0 mb-0">
                                      {this?.state?.totalDaywiseData}
                                    </h6>
                                  </div>
                                </div>
                              </div>
                              <div className="col-sm-2">
                                <div className="card">
                                  <div className="card-body p-2">
                                    <h5 className="card-title mb-0">Delivered</h5>
                                    <h6 className="mt-0 mb-0">
                                      {this.state.totalDaywiseDeliver}
                                    </h6>
                                  </div>
                                </div>
                              </div>

                              <div className="col-sm-2">
                                <div className="card">
                                  <div className="card-body p-2">
                                    <h5 className="card-title mb-0">Failed</h5>
                                    <h6 className="mt-0 mb-0">
                                      {this.state.totalDaywiseFailed}
                                    </h6>
                                  </div>
                                </div>
                              </div>

                              {this.state.daywiseChannel === "whatsapp" ?
                                <> <div className="col-sm-2">
                                  <div className="card">
                                    <div className="card-body p-2">
                                      <h5 className="card-title mb-0">Sent</h5>
                                      <h6 className="mt-0 mb-0">
                                        {this.state.totalDaywiseSent}
                                      </h6>
                                    </div>
                                  </div>
                                </div>

                                  <div className="col-sm-2">
                                    <div className="card">
                                      <div className="card-body p-2">
                                        <h5 className="card-title mb-0">Read</h5>
                                        <h6 className="mt-0 mb-0">
                                          {this.state.totalDaywiseRead}
                                        </h6>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-sm-2">
                                    <div className="card">
                                      <div className="card-body p-2">
                                        <h5 className="card-title mb-0">Optout</h5>
                                        <h6 className="mt-0 mb-0">
                                          {this.state.totalDaywiseOptout}
                                        </h6>
                                      </div>
                                    </div>
                                  </div> </> :
                                <div className="col-sm-2">
                                  <div className="card">
                                    <div className="card-body p-2">
                                      <h5 className="card-title mb-0">DND</h5>
                                      <h6 className="mt-0 mb-0">
                                        {this.state.totalDaywiseDnd}
                                      </h6>
                                    </div>
                                  </div>
                                </div>}

                              <div className="col-sm-2">
                                <div className="card">
                                  <div className="card-body p-2">
                                    <h5 className="card-title mb-0">Other</h5>
                                    <h6 className="mt-0 mb-0">
                                      {this.state.totalDaywiseOther}
                                    </h6>
                                  </div>
                                </div>
                              </div>

                            </div>
                          }
                        </>}
                    </div>
                  </div>
                </div>

                {this.state.successShow ? (
                  <div className={this.state.bgColor} role="alert">
                    <button
                      type="button"
                      className="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">×</span>
                    </button>
                    <div className="">{this.state.errorMessage}</div>
                  </div>
                ) : null}

                <div className="row justify-content-center">
                  <div className="col-12 col-lg-12 col-xxl-12 d-flex">
                    <div className="card flex-fill ">
                      <ol className="breadcrumb bg-transparent p-0 mt-1 mb-0 ml-3">
                        <span
                          className="breadcrumb bg-transparent p-0 mt-1 mb-0"
                          style={{ cursor: "pointer" }}
                          onClick={() => this.setState({ campaignReport: !this.state.campaignReport, numberFilterSearch: false, scheduleReport: false, templateSummary: false, daywisesummary: false, campaignList: [], templateSummaryList: {}, startDate: new Date(), endDate: new Date() })}
                        >
                          <li className={this.state.campaignReport ? "breadcrumb-item active" : "breadcrumb-item"}>
                            Campaign Report
                          </li>
                        </span>
                        <span className="breadcrumb bg-transparent p-0 mt-1 mb-0" style={{ cursor: "pointer" }} onClick={() => this.setState({ numberFilterSearch: true, daywisesummary: false, scheduleReport: false, campaignReport: false, templateSummary: false, campaignList: [], templateSummaryList: {}, startDate: new Date(), endDate: new Date() })}>
                          <li className={this.state.numberFilterSearch ? "breadcrumb-item active" : "breadcrumb-item"}>Number Filter Search</li>
                        </span>
                        <span className="breadcrumb bg-transparent p-0 mt-1 mb-0" style={{ cursor: "pointer" }} onClick={() => this.setState({ templateSummary: true, daywisesummary: false, numberFilterSearch: false, scheduleReport: false, campaignReport: false, campaignList: [], templateSummaryList: {}, startDate: new Date(), endDate: new Date() })}>
                          <li className={this.state.templateSummary ? "breadcrumb-item active" : "breadcrumb-item"}>Template Summary</li>
                        </span>
                        <span className="breadcrumb bg-transparent p-0 mt-1 mb-0" style={{ cursor: "pointer" }} onClick={() => this.setState({ daywisesummary: true, templateSummary: false, numberFilterSearch: false, scheduleReport: false, campaignReport: false, campaignList: [], templateSummaryList: {}, startDate: new Date(), endDate: new Date() })}>
                          <li className={this.state.daywisesummary ? "breadcrumb-item active" : "breadcrumb-item"}>Day Wise Summary</li>
                        </span>
                        <span className="breadcrumb bg-transparent p-0 mt-1 mb-0" style={{ cursor: "pointer" }} onClick={() => this.setState(this.goToScheduleReport)}>
                          <li className={this.state.scheduleReport ? "breadcrumb-item active" : "breadcrumb-item"}>Schedule Campaign</li>
                        </span>
                      </ol>
                      <hr />
                      {this.state.campaignReport &&
                        <>
                          {/* <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <div className="col-4">
                          <h3 className="mt-2 ml-3">Campaign Report</h3>
                          </div>
                          <div className="col-6 d-flex justify-content-end align-items-center" style={{ display: 'flex', alignItems: 'center', marginRight: '20px' }}>
                            <label className="mr-2 mt-4" style={{ whiteSpace: 'nowrap' }}>Select channel</label>
                            <select onChange={this.channelHandler} className="form-control mt-3 ">
                              <option value="all">All</option>
                              <option value="whatsapp">Whatsapp</option>
                              <option value="sms">SMS</option>
                              <option value="rcs">RCS</option>
                            </select>
                          </div>
                        </div> */}

                          <div className="card-header">
                            {/* <div className="row"> */}
                            {/* <div className="col-5 ">
                              <label>From:</label>
                              <ReactDatePicker
                                dateFormat="dd/MM/yyyy"
                                selected={this.state.startDate}
                                className="form-control ml-2"
                                onChange={(date) => this.startDateHandler(date)}
                                selectsStart
                                startDate={this.state.startDate}
                              />
                            </div> */}
                            {/* <div className="col-5">
                              <label>To:</label>
                              <ReactDatePicker
                                dateFormat="dd/MM/yyyy"
                                className="form-control ml-2"
                                selected={this.state.endDate}
                                onChange={(date) => this.endDateHandler(date)}
                                selectsEnd
                                startDate={this.state.startDate}
                                minDate={this.state.startDate}
                                maxDate={this.state.maxDate}
                              />
                            </div> */}
                            {/* <div className="col-2"> */}
                            {/* <label></label><br/> */}
                            {/* {this.state.loadingBtn ? (
                                <button className="btn btn-success float-right p-2 mr-3" type="button" disabled>
                                  <span
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>
                                  <span className="sr-only">Loading...</span>
                                </button>
                              ) : (
                                <button
                                  className="btn btn-success float-right p-2 mr-3"
                                  onClick={() => this.getCampaignList(this.state.channel)}
                                >
                                  <FontAwesomeIcon className="fa-lg" icon={faSearch} />
                                </button>
                              )}

                            </div> */}
                            {/* </div> */}

                            <div className="row g-2 align-items-end">
                              <div className="col-12 col-sm-6 col-md-3">
                                <label>Select channel</label>
                                <select onChange={this.channelHandler} className="form-control">
                                  <option value="all">All</option>
                                  <option value="whatsapp">Whatsapp</option>
                                  <option value="sms">SMS</option>
                                  <option value="rcs">RCS</option>
                                </select>
                              </div>
                              <div className="col-12 col-sm-6 col-md-4">
                                <label>From:</label>
                                <div className="input-group mb-2 mr-sm-2">
                                  <div className="input-group-text">
                                    <FontAwesomeIcon icon={faCalendarAlt} />
                                  </div>
                                  <div>
                                    <ReactDatePicker
                                      className="form-control btn-block"
                                      dateFormat="dd/MM/yyyy"
                                      onChange={(date) => this.startDateHandler(date)}
                                      selectsStart
                                      startDate={this.state.startDate}
                                      selected={this.state.startDate}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-12 col-sm-6 col-md-4">
                                <label>To:</label>
                                <div className="input-group mb-2 mr-sm-2">
                                  <div className="input-group-text">
                                    <FontAwesomeIcon icon={faCalendarAlt} />
                                  </div>
                                  <div>
                                    <ReactDatePicker
                                      className="form-control btn-block"
                                      dateFormat="dd/MM/yyyy"
                                      selected={this.state.endDate}
                                      onChange={(date) => this.endDateHandler(date)}
                                      selectsEnd
                                      startDate={this.state.startDate}
                                      minDate={this.state.startDate}
                                      maxDate={this.state.maxDate}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-12 col-sm-6 col-md-1">
                                <label></label>
                                {this.state.loadingBtn ? (
                                  <button className="btn btn-success float-right" type="button" disabled>
                                    <span
                                      className="spinner-border spinner-border-sm"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                    {/* <span className="sr-only">Loading...</span> */}
                                  </button>
                                ) : (
                                  <button
                                    className="btn btn-success float-right"
                                    onClick={() => this.getCampaignList(this.state.channel)}
                                  >
                                    <FontAwesomeIcon className="fa-lg" icon={faSearch} />
                                  </button>
                                )}

                              </div>
                              {/* <div className="col-6">
                              <label>To:</label>
                              <div className="input-group mb-2 mr-sm-2">
                                <div className="input-group-text">
                                  <FontAwesomeIcon icon={faCalendarAlt} />
                                </div>

                                <ReactDatePicker
                                  className="form-control btn-block"
                                  dateFormat="dd/MM/yyyy"
                                  selected={this.state.endDate}
                                  onChange={(date) => this.endDateHandler(date)}
                                  selectsEnd
                                  startDate={this.state.startDate}
                                  minDate={this.state.startDate}
                                  maxDate={this.state.maxDate}
                                />
                              </div>
                            </div> */}

                              {/* <div className="row">
                              <div className="col-6">
                              </div>
                              <div className="col-6">
                               
                                {this.state.loadingBtn ? (
                                  <button className="btn btn-success float-right p-2 mr-5" type="button" disabled>
                                    <span
                                      className="spinner-border spinner-border-sm"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                    <span className="sr-only">Loading...</span>
                                  </button>
                                ) : (
                                  <button
                                    className="btn btn-success float-right p-2 mr-5"
                                    onClick={() => this.getCampaignList(this.state.channel)}
                                  >
                                    <FontAwesomeIcon className="fa-lg" icon={faSearch} />
                                  </button>
                                )}

                              </div>
                            </div> */}
                            </div>

                            {(this?.state?.campaignList?.length > 0 && this.state.channel !== "all") &&
                              <div className="d-flex justify-content-end mt-2">
                                <button onClick={this.exportToExcel} className="btn btn-warning btn-sm">
                                  <FontAwesomeIcon icon={faDownload} className="mr-1" /> Download Summary
                                </button>
                              </div>}
                            {/* <div className="d-flex flex-column">
                      <div className="d-flex align-items-center mb-2">
                        <label className="mr-2 mb-0">From:</label>
                        <label className="mr-2 mb-0">To:</label>
                      </div>
                      <div className="d-flex align-items-center">
                        <ReactDatePicker
                          dateFormat="dd/MM/yyyy"
                          selected={this.state.startDate}
                          className="form-control mr-2"
                          onChange={(date) => this.startDateHandler(date)}
                          selectsStart
                          startDate={this.state.startDate}
                        />
                        <ReactDatePicker
                          dateFormat="dd/MM/yyyy"
                          className="form-control mr-2"
                          selected={this.state.endDate}
                          onChange={(date) => this.endDateHandler(date)}
                          selectsEnd
                          startDate={this.state.startDate}
                          minDate={this.state.startDate}
                          maxDate={this.state.maxDate}
                        />
                        <div>
                          {this.state.loadingBtn ? (
                            <button className="btn btn-success p-2" type="button" disabled>
                              <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              <span className="sr-only">Loading...</span>
                            </button>
                          ) : (
                            <button
                              className="btn btn-success p-2"
                              onClick={() => this.getCampaignList(this.state.channel)}
                            >
                              <FontAwesomeIcon className="fa-lg" icon={faSearch} />
                            </button>
                          )}
                        </div>
                      </div>
                    </div> */}
                          </div>
                        </>}

                      {this.state.numberFilterSearch &&
                        <>
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            {/* <h3 className="mt-2 ml-3">Campaign Report</h3> */}
                            <div style={{ display: 'flex', alignItems: 'center', marginRight: '20px' }}>
                              {/* <div className="input-group drop-down-icons mt-2"> */}

                              {/* </div> */}
                            </div>
                          </div>

                          <div className="card-header">
                            <div className="row g-2">
                              <div className="col-12 col-sm-6">
                                <label>Select Channel</label>
                                <select onChange={this.channelHandlerFilterSearch} className="form-control">
                                  <option value="">Select Channel</option>
                                  <option value="whatsapp">Whatsapp</option>
                                  <option value="sms">SMS</option>
                                  <option value="rcs">RCS</option>
                                </select>
                              </div>
                              <div className="col-12 col-sm-6">
                                <label>Search Number</label>
                                <input type="text" value={this.state.search} onChange={(e) => this.setState({ search: e.target.value })} placeholder="Search Number" className="form-control" />
                              </div>
                            </div>
                            <div className="row g-2 mt-1 align-items-end">
                              <div className="col-12 col-sm-6 col-md-4">
                                <label>From:</label>
                                <div className="input-group mb-2 mr-sm-2">
                                  <div className="input-group-text">
                                    <FontAwesomeIcon icon={faCalendarAlt} />
                                  </div>
                                  <ReactDatePicker
                                    className="form-control btn-block"
                                    dateFormat="dd/MM/yyyy"
                                    onChange={(date) => this.startDateHandler(date)}
                                    selectsStart
                                    startDate={this.state.startDate}
                                    selected={this.state.startDate}
                                  />
                                </div>
                              </div>
                              <div className="col-12 col-sm-6 col-md-4">
                                <label>To:</label>
                                <div className="input-group mb-2 mr-sm-2">
                                  <div className="input-group-text">
                                    <FontAwesomeIcon icon={faCalendarAlt} />
                                  </div>
                                  <ReactDatePicker
                                    className="form-control btn-block"
                                    dateFormat="dd/MM/yyyy"
                                    selected={this.state.endDate}
                                    onChange={(date) => this.endDateHandler(date)}
                                    selectsEnd
                                    startDate={this.state.startDate}
                                    minDate={this.state.startDate}
                                    maxDate={this.state.maxDate}
                                  />
                                </div>
                              </div>

                              <div className="row g-2">
                                <div className="col-6">
                                  {/* <button type="button" onClick={this.searchByNumber} className="btn btn-info float-right mt-3">Filter Search</button> */}
                                </div>
                                <div className="col-6">
                                  {/* <label></label><br/> */}
                                  {this.state.loadingBtn ? (
                                    <button className="btn btn-success float-right p-2 mr-3" type="button" disabled>
                                      <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                      ></span>
                                      <span className="sr-only">Loading...</span>
                                    </button>
                                  ) : (
                                    <button
                                      className="btn btn-success float-right p-2 mr-3"
                                      // onClick={() => this.getCampaignList(this.state.channel)}
                                      onClick={this.searchByNumber}
                                    >
                                      <FontAwesomeIcon className="fa-lg" icon={faSearch} />
                                    </button>
                                  )}

                                </div>
                              </div>
                            </div>
                            {/* <div className="d-flex flex-column">
                      <div className="d-flex align-items-center mb-2">
                        <label className="mr-2 mb-0">From:</label>
                        <label className="mr-2 mb-0">To:</label>
                      </div>
                      <div className="d-flex align-items-center">
                        <ReactDatePicker
                          dateFormat="dd/MM/yyyy"
                          selected={this.state.startDate}
                          className="form-control mr-2"
                          onChange={(date) => this.startDateHandler(date)}
                          selectsStart
                          startDate={this.state.startDate}
                        />
                        <ReactDatePicker
                          dateFormat="dd/MM/yyyy"
                          className="form-control mr-2"
                          selected={this.state.endDate}
                          onChange={(date) => this.endDateHandler(date)}
                          selectsEnd
                          startDate={this.state.startDate}
                          minDate={this.state.startDate}
                          maxDate={this.state.maxDate}
                        />
                        <div>
                          {this.state.loadingBtn ? (
                            <button className="btn btn-success p-2" type="button" disabled>
                              <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              <span className="sr-only">Loading...</span>
                            </button>
                          ) : (
                            <button
                              className="btn btn-success p-2"
                              onClick={() => this.getCampaignList(this.state.channel)}
                            >
                              <FontAwesomeIcon className="fa-lg" icon={faSearch} />
                            </button>
                          )}
                        </div>
                      </div>
                    </div> */}
                          </div>
                        </>}



                      {this.state.campaignReport ?
                        <>
                          {this.state.loading === true ? (
                            <Spining />
                          ) : (
                            <div className="col-md-12 mt-2">
                              {this.state.campaignList < 1 && (
                                <div className="card d-flex justify-content-center align-items-center ">
                                  <h6 className="mt-2">No Record Found</h6>
                                </div>
                              )}
                              {this.state.campaignList?.map((item, i) => (
                                <div className="card" key={i}>
                                  <div className="card-body">
                                    <div className="d-flex  justify-content-between campaign-flex-wrap">
                                      <p>
                                        {" "}
                                        {
                                          (this.state.channel === "whatsapp" || this.state.channel === "all") && item.campaign_type === "whatsapp" ?
                                            <IoLogoWhatsapp className="text-success mr-2" style={{ fontSize: '2em' }} /> : null
                                        }

                                        {
                                          (this.state.channel === "sms" || this.state.channel === "all") && item.campaign_type === "sms" ?
                                            <FaSms className="text-primary mr-2" style={{ fontSize: '2em' }} /> : null
                                        }

                                        {
                                          (this.state.channel === "rcs" || this.state.channel === "all") && item._id ?
                                            // <FaMessage className="text-primary mr-2" style={{ fontSize: '2em' }} />
                                            <img alt="Rcs Image" className="text-primary mr-2 rcs-logo-image" style={{ fontSize: '2em', width: '30px', height: '30px' }} src={RcsImage} />

                                            : null
                                        }

                                        <span>Campaign Name:{" "}</span>
                                        <span style={{ fontWeight: "bold" }}>
                                          {item.campaign_name}{" "}
                                        </span>{" "}
                                      </p>
                                      <p>
                                        {(this.state.channel === "sms" || this.state.channel === "all") && item.campaign_type === "sms" ? (
                                          <>
                                            {item.status === 0 ? (
                                              <span className="badge bg-danger">
                                                Deleted
                                              </span>
                                            ) : item.status === 1 ? (
                                              <span className="badge bg-info">
                                                Not Split
                                              </span>
                                            ) : item.status === 2 ? (
                                              <span className="badge bg-warning">
                                                Schedule
                                              </span>
                                            ) : item.status === 3 ? (
                                              <span className="badge bg-success">
                                                Completed
                                              </span>
                                            ) : item.status === 4 ? (
                                              <span className="badge bg-danger">
                                                Schedule Deleted
                                              </span>
                                            ) : null
                                            }
                                          </>
                                        ) : (this.state.channel === "whatsapp" || this.state.channel === "all") && item.campaign_type === "whatsapp" ? (
                                          <>
                                            {(item.status === 0 || item.status === 1) ? (
                                              <span className="badge bg-info">
                                                Submitted
                                              </span>
                                            ) : item.status === 2 ? (
                                              <span className="badge bg-info">
                                                Schedule
                                              </span>
                                            ) : item.status === 3 ? (
                                              <span className="badge bg-success">
                                                Processing
                                              </span>
                                            ) : item.status === 5 ? (
                                              <span className="badge bg-warning">
                                                Schedule
                                              </span>
                                            ) : item.status === 4 ? (
                                              <span className="badge bg-primary ">
                                                Completed
                                              </span>
                                            ) : item.status === 6 ? (
                                              <span className="badge bg-danger">
                                                Schedule Deleted
                                              </span>
                                            ) : item.status === 7 ? (
                                              <>
                                                <span className="badge bg-danger ">
                                                  Rejected
                                                  <FontAwesomeIcon
                                                    className="ml-1"
                                                    icon={faInfoCircle}
                                                    title="Not Send Due to Template Rejection"
                                                  />

                                                </span>
                                              </>
                                            ) : null}
                                          </>
                                        ) : (this.state.channel === "rcs" || this.state.channel === "all") && item._id ? (
                                          <>
                                            {item.status === 1 ? (
                                              <span className="badge bg-info">
                                                Processing
                                              </span>
                                            ) : item.status === 2 ? (
                                              <span className="badge bg-info">
                                                Schedule
                                              </span>
                                            ) : item.status === 3 ? (
                                              <span className="badge bg-success mr-5">
                                                Completed
                                              </span>
                                            ) : item.status === 4 ? (
                                              <span className="badge bg-primary ">
                                                Schedule Deleted
                                              </span>
                                            ) : null}
                                          </>
                                        ) : null}

                                      </p>
                                      {(this.state.channel === "whatsapp" || this.state.channel === "all") && item.campaign_type === "whatsapp" && formattedDate < item.camp_start_datetime && (item.status === 5 || item.status === 2) ?
                                        <p>
                                          <span onClick={() => this.showWhatsappDeletePopup(item.id, item.campaign_name, item.campaign_type)} style={{ cursor: "pointer" }}><FontAwesomeIcon icon={faTrashAlt} /></span>
                                        </p> : null}
                                      {(this.state.channel === "sms" || this.state.channel === "all") && item.campaign_type === "sms" && formattedDate < item.camp_start_datetime && item.status === 2 ?
                                        <p>
                                          <span onClick={() => this.showSmsDeletePopup(item.id, item.campaign_name, item.campaign_type)} style={{ cursor: "pointer" }}><FontAwesomeIcon icon={faTrashAlt} /></span>
                                        </p> : null}
                                      {(this.state.channel === "rcs" || this.state.channel === "all") && item._id &&
                                        dayjs(item.camp_start_datetime).isAfter(dayjs(formattedDate).add(10, 'minute')) ?
                                        <p>
                                          <span onClick={() => this.showPopup(item._id, item.campaign_name, item.camp_start_datetime)} className="badge bg-warning">
                                            Reschedule
                                          </span>
                                        </p> : null}

                                      {(this.state.channel === "rcs" || this.state.channel === "all") && item._id &&
                                        dayjs(item.camp_start_datetime).isAfter(dayjs(formattedDate).add(10, 'minute')) ?
                                        <p>
                                          <span onClick={() => this.showDeletePopup(item._id, item.campaign_name)} className="badge bg-danger">
                                            Delete
                                          </span>
                                        </p> : null}

                                    </div>

                                    <div className="row">
                                      <div className="d-flex justify-content-end">
                                        <p className="mb-0">
                                          <small>
                                            Campaign Date: {dayjs(item.camp_start_datetime).format("DD/MM/YYYY h:mm A")}
                                          </small>
                                        </p>
                                      </div>
                                    </div>

                                    <hr className="m-0 mb-1"></hr>
                                    <div className="d-flex flex-wrap summary-data text-center">
                                      <div className="summary-item mb-1">
                                        <span className="text-muted label"> total </span>{" "}
                                        <br />
                                        <span className="textvalue text-success value">
                                          {" "}
                                          {/* <FontAwesomeIcon
                                    icon={faArrowUp}
                                    color="green"
                                    size="1x"
                                  />{" "} */}
                                          {item.contact_count}{" "}
                                        </span>{" "}
                                      </div>

                                      <div className="summary-item mb-1">
                                        <span className="text-muted label">
                                          {" "}
                                          Delivered{" "}
                                        </span>{" "}
                                        <br />
                                        <span className="textvalue text-success value">
                                          {" "}
                                          {/* <FontAwesomeIcon
                                    icon={faArrowUp}
                                    color="green"
                                    size="1x"
                                  />{" "} */}
                                          {(this.state.channel === "rcs" || this.state.channel === "all") && item._id ? item.deliver_count : item.delivered}{" "}
                                        </span>{" "}
                                      </div>

                                      <div className="summary-item mb-1">
                                        <span className="text-muted label"> Failed </span>
                                        <br />{" "}
                                        <span className="textvalue text-success value">
                                          {" "}
                                          {/* <FontAwesomeIcon
                                    icon={faArrowDown}
                                    color="red"
                                    size="1x"
                                  />{" "} */}
                                          {(this.state.channel === "rcs" || this.state.channel === "all") && item._id ? item.fail_count : item.failed}{" "}
                                        </span>{" "}
                                      </div>

                                      {(this.state.channel === "sms" || this.state.channel === "all") && item.campaign_type === "sms" ?
                                        (
                                          <>
                                            <div className="summary-item mb-1">
                                              <span className="text-muted label"> Opt Out </span>
                                              <br />{" "}
                                              <span className="textvalue text-success value">
                                                {" "}
                                                {/* <FontAwesomeIcon
                                 icon={faArrowDown}
                                 color="red"
                                 size="1x"
                               />{" "} */}
                                                {item.optout}{" "}
                                              </span>{" "}
                                            </div>

                                            <div className="summary-item mb-1">
                                              <span className="text-muted label"> DND </span>
                                              <br />{" "}
                                              <span className="textvalue text-success value">
                                                {" "}
                                                {/* <FontAwesomeIcon
                                    icon={faArrowDown}
                                    color="red"
                                    size="1x"
                                  />{" "} */}
                                                {item.dnd || 0}{" "}
                                              </span>{" "}
                                            </div>

                                            <div className="summary-item mb-1">
                                              <span className="text-muted label"> Other </span>
                                              <br />{" "}
                                              <span className="textvalue text-success value">
                                                {" "}
                                                {/* <FontAwesomeIcon
                                    icon={faArrowDown}
                                    color="red"
                                    size="1x"
                                  />{" "} */}
                                                {item.other || 0}{" "}
                                              </span>{" "}
                                            </div>

                                          </>
                                        ) : (
                                          <>
                                            <div className="summary-item mb-1">
                                              <span className="text-muted label"> Sent </span>{" "}
                                              <br />
                                              <span className="textvalue value">
                                                {" "}
                                                <FontAwesomeIcon
                                                  icon={faArrowUp}
                                                  color="green"
                                                  size="1x"
                                                />{" "}
                                                {(this.state.channel === "rcs" || this.state.channel === "all") && item._id ? item.sent_count : item.sent}{" "}
                                              </span>{" "}
                                            </div>

                                            <div className="summary-item mb-1">
                                              <span className="text-muted label"> Read </span>
                                              <br />{" "}
                                              <span className="textvalue value">
                                                {" "}
                                                <FontAwesomeIcon
                                                  icon={faArrowUp}
                                                  color="green"
                                                  size="1x"
                                                />{" "}
                                                {(this.state.channel === "rcs" || this.state.channel === "all") && item._id ? item.read_count : item.read}{" "}
                                              </span>{" "}
                                            </div>

                                            {((this.state.channel === "whatsapp" || this.state.channel === "all") && item.campaign_type === "whatsapp") &&
                                              <>
                                                <div className="summary-item mb-1">
                                                  <span className="text-muted label"> Optout </span>
                                                  <br />{" "}
                                                  <span className="textvalue value">
                                                    {" "}
                                                    <FontAwesomeIcon
                                                      icon={faArrowUp}
                                                      color="green"
                                                      size="1x"
                                                    />{" "}
                                                    {item.optout}{" "}
                                                  </span>{" "}
                                                </div>
                                                <div className="summary-item mb-1">
                                                  <span className="text-muted label"> Other </span>
                                                  <br />{" "}
                                                  <span className="textvalue text-success value">
                                                    {" "}
                                                    {/* <FontAwesomeIcon
                                    icon={faArrowDown}
                                    color="red"
                                    size="1x"
                                  />{" "} */}
                                                    {item.other || 0}{" "}
                                                  </span>{" "}
                                                </div>
                                              </>}
                                          </>
                                        )}

                                      {this.state.route === 36 && (this.state.channel === "whatsapp" || this.state.channel === "all") && item.campaign_type === "whatsapp" ?
                                        <div className="summary-item mb-1">
                                          <span className="text-muted label"> CTA </span>
                                          <br />{" "}
                                          {item.cta_tracking === 0 ?
                                            <span className="textvalue value">{item.cta_tracking}</span>
                                            :
                                            <Link
                                              to={`/dashboard/campaign/cta-report/${item.id}`}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                            >
                                              <span className=" text-success">
                                                <FontAwesomeIcon icon={faEye} />
                                              </span>
                                            </Link>
                                          }
                                        </div> : null}

                                      <>
                                        {(item.archive_status === 1 || ((item.channel === "all" || item.campaign_type === "whatsapp") && item.status === 6)) ? null : <div className="summary-item mb-1">
                                          <span className="text-muted label"> Report </span>
                                          <br />{" "}
                                          <Link
                                            // to={`/dashboard/campaign/detailed-report/${item.channel}/${(this.state.channel === "rcs" || this.state.channel === "all") && item._id ? item._id : item.id}/${item.campaign_name}/${item.contact_count}`}
                                            to={`/dashboard/campaign/detailed-report/${item.channel === "all" && item._id ? "rcs" : item.channel === "all" && item.campaign_type === "sms" ? "sms" : item.channel === "all" && !item._id && item.campaign_type !== "sms" ? "whatsapp" : item.channel}/${(this.state.channel === "rcs" || this.state.channel === "all") && item._id ? item._id : item.id}/${encodeURIComponent(item.campaign_name)}/${((this.state.channel === "sms" || this.state.channel === "all")&& item.campaign_type === "sms") ? item.num_count : item.contact_count}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            <span className="text-success value">
                                              <FontAwesomeIcon className="mt-3" icon={faEye} />
                                            </span>
                                          </Link>
                                        </div>}
                                        {(this.state.channel === "rcs" || this.state.channel === "all") && item._id ? (
                                          <div className="summary-item mb-1">
                                            <span className="text-muted label"> Click Report </span>
                                            <br />{" "}
                                            <span
                                              className="text-success value"
                                              style={{ cursor: "pointer" }}
                                              onClick={() => this.openClickReportModal()}
                                            >
                                              <FontAwesomeIcon className="mt-3" icon={faEye} />
                                            </span>
                                          </div>
                                        ) : null}
                                        {/* <div className="summary-item mb-1">
                                        <span className="text-muted label"> Download </span>
                                        <br />{" "}
                                        <a
                                          href={(this.state.channel === "sms" || this.state.channel === "all") 
                                            && item.campaign_type === "sms" ? `${HOST_URL_DB2}/bulk_campaign_sms.php?user_id=${item.user_id}&method=download&token=${item.user_token}&channel=sms&campaign_id=${item.id}&archive_status=${item.archive_status}&camp_start_datetime=${item.camp_start_datetime}` 
                                            : (this.state.channel === "whatsapp" || this.state.channel === "all") 
                                            && item.campaign_type === "whatsapp" ? `${HOST_URL}/bulk_campaign.php?user_id=${item.user_id}&method=download&campaign_id=${item.id}&channel=whatsapp&token=${item.user_token}`
                                             : (this.state.channel === "rcs" || this.state.channel === "all") 
                                            && item._id ? `${NODE_HOST_URL}/rcs?user_id=${item.user_id}&token=${item.user_token}&method=campaign_report_download&campaign_id=${item._id}` : null}
                                          className="text-success value"
                                        >
                                          <FontAwesomeIcon className="mt-3" icon={faDownload} />{" "}
                                        </a>
                                      </div> */}
                                        <div className="summary-item mb-1">
                                          {(this.state.channel === "rcs" || this.state.channel === "all") &&
                                            item._id &&
                                            !(item.archive_status === 1 && this.state.encryptData.rcs === 1) && (
                                              <span className="text-muted label">Download</span>
                                            )}
                                          {(this.state.channel === "sms" || this.state.channel === "all") &&
                                            item.campaign_type === "sms" &&
                                            !(item.archive_status === 1 && this.state.encryptData.sms === 1) && (
                                              <span className="text-muted label">Download</span>
                                            )}

                                          {/* ===== WHATSAPP DOWNLOAD ===== */}
                                          {(this.state.channel === "whatsapp" || this.state.channel === "all") &&
                                            item.campaign_type === "whatsapp" &&

                                            ((item.archive_status === 1 &&
                                              this.state.encryptData.whatsapp === 1) || item.status === 6
                                              ? null
                                              : <span className="text-muted label">Download</span>
                                            )
                                          }
                                          <br />

                                          {/* ===== RCS DOWNLOAD ===== */}
                                          {(this.state.channel === "rcs" || this.state.channel === "all") &&
                                            item._id &&
                                            !(item.archive_status === 1 && this.state.encryptData.rcs === 1) && (
                                              <span
                                                className="text-success value"
                                                style={{ cursor: this.state.downloadingCampaigns[item._id] ? "not-allowed" : "pointer" }}
                                                onClick={() => !this.state.downloadingCampaigns[item._id] && this.handleRcsDownload(item)}
                                              >
                                                <FontAwesomeIcon 
                                                  className="mt-3" 
                                                  icon={this.state.downloadingCampaigns[item._id] ? faSpinner : faDownload}
                                                  spin={this.state.downloadingCampaigns[item._id]}
                                                />
                                              </span>
                                            )}

                                          {/* ===== SMS DOWNLOAD ===== */}
                                          {(this.state.channel === "sms" || this.state.channel === "all") &&
                                            item.campaign_type === "sms" &&
                                            !(item.archive_status === 1 && this.state.encryptData.sms === 1) && (
                                              <span
                                                className="text-success value"
                                                style={{ cursor: this.state.downloadingCampaigns[item.id] ? "not-allowed" : "pointer" }}
                                                onClick={() => !this.state.downloadingCampaigns[item.id] && this.handleSmsDownload(item)}
                                              >
                                                <FontAwesomeIcon 
                                                  className="mt-3" 
                                                  icon={this.state.downloadingCampaigns[item.id] ? faSpinner : faDownload}
                                                  spin={this.state.downloadingCampaigns[item.id]}
                                                />
                                              </span>
                                            )}

                                          {/* ===== WHATSAPP DOWNLOAD ===== */}
                                          {(this.state.channel === "whatsapp" || this.state.channel === "all") &&
                                            item.campaign_type === "whatsapp" &&

                                            ((item.archive_status === 1 &&
                                              this.state.encryptData.whatsapp === 1) || item.status === 6
                                              ? null
                                              :
                                              <span
                                                className="text-success value"
                                                style={{ cursor: this.state.downloadingCampaigns[item.id] ? "not-allowed" : "pointer" }}
                                                onClick={() => !this.state.downloadingCampaigns[item.id] && this.handleWhatsappDownload(item)}
                                              >
                                                <FontAwesomeIcon 
                                                  className="mt-3" 
                                                  icon={this.state.downloadingCampaigns[item.id] ? faSpinner : faDownload}
                                                  spin={this.state.downloadingCampaigns[item.id]}
                                                />
                                              </span>
                                            )
                                          }
                                        </div>
                                      </>
                                    </div>
                                    <div className="d-flex justify-content-between mt-1">
                                      <div className="d-flex">
                                        <small className="m-0, p-0">
                                          <span style={{ color: "black" }}>Campaign ID:</span> <span style={{ color: "#4c0af5" }}>{(this.state.channel === "rcs" || this.state.channel === "all") && item._id ? item._id : item.id}</span><span style={{ color: "black" }}>/</span>
                                        </small>
                                        {/* {this.state.channel === "sms" ? <small>Template ID:  xxxxxxxx{item?.template_id?.substr(-4,4)}/</small> :
                                  <small>Template ID: {item?.template_id}/</small>} */}
                                        {((this.state.channel === "whatsapp" || this.state.channel === "all") && item.campaign_type === "whatsapp") && <small style={{ color: "black" }}>BrandNumber: <span style={{ color: "#4c0af5" }}>{item?.from_mobile}</span><span className="no-style">/</span></small>}
                                        {(this.state.channel === "sms" || this.state.channel === "all") && item.campaign_type === "sms" ? <small style={{ color: "black" }}>Template ID: <span style={{ color: "#4c0af5" }}>{item?.template_id}</span><span className="no-style">/</span></small> :
                                          (this.state.channel === "rcs" || this.state.channel === "all") && item._id ?
                                            <>
                                              <small style={{ color: "black", fontSize: "12px" }}>Template Name: <span style={{ color: "#4c0af5", fontSize: "10px" }}>{item?.template_id}{" "}</span></small>
                                              <small>/
                                                <span style={{ color: "black", fontSize: "12px" }}>Sender ID:</span> <span style={{ color: "#4c0af5", fontSize: "10px" }}>{item?.sender_id}</span>
                                              </small>
                                              <small>/
                                                {/* <span style={{ color: "black", fontSize:"12px" }}>Campaign Name:</span> <span style={{ color: "#4c0af5", fontSize:"10px" }}>{item?.template_id}</span> */}
                                              </small>
                                              <small>/
                                                <span style={{ color: "black", fontSize: "12px" }}>Submit From:</span> <span style={{ color: "#4c0af5", fontSize: "10px" }}>{item?.submit_from}</span>
                                              </small>
                                            </> :
                                            <small>
                                              <span style={{ color: "black" }}>Template ID:</span> <span style={{ color: "#4c0af5" }}>{item?.template_id}</span>
                                            </small>}

                                        {(this.state.channel === "whatsapp" || this.state.channel === "all") && item.campaign_type === "whatsapp" ?
                                          <>
                                            /<small>
                                              <span style={{ color: "black" }}>Message Type:</span> <span style={{ color: "#4c0af5" }}>{item?.message_type === 1 ? <span>Marketing</span> : item?.message_type === 2 ? <span>Utility</span> : item?.message_type === 3 ? <span>Authentication</span> : null}</span>
                                            </small>
                                            /<small>
                                              <span style={{ color: "black" }}>Country Code:</span> <span style={{ color: "#4c0af5" }}>{item?.country_code}</span>
                                            </small>
                                            <small>/
                                              <span style={{ color: "black" }}>Submit From:</span> <span style={{ color: "#4c0af5" }}>{item?.submit_from}</span>
                                            </small>
                                            <small
                                              style={{
                                                cursor: 'pointer',
                                                backgroundColor: this.state.openTemplatePopup ? '#f0f0f0' : 'transparent',
                                              }}
                                              className="ml-2"
                                              onClick={() => this.TemplateListDetails(item?.template_id)}>
                                              <FontAwesomeIcon icon={faInfoCircle} />
                                            </small>
                                          </> : null}
                                        {(this.state.channel === "sms" || this.state.channel === "all") && item.campaign_type === "sms" ? <small style={{ color: "black" }}>Sender ID: <span style={{ color: "#4c0af5" }}>{item.sender_id}</span></small> : null}
                                        {(
                                          (this.state.channel === "sms" || this.state.channel === "all") &&
                                          item.campaign_type === "sms"
                                        ) && (
                                            <small
                                              style={{
                                                cursor: 'pointer',
                                                backgroundColor: this.state.openTemplatePopup ? '#f0f0f0' : 'transparent',
                                              }}
                                              className="ml-2"
                                              onClick={() => this.OpenContactCountpopup(item)}>
                                              <FontAwesomeIcon icon={faInfoCircle} />
                                            </small>
                                          )}
                                      </div>
                                      {((this.state.channel === "whatsapp" || this.state.channel === "all") && item.campaign_type === "whatsapp") && (
                                        <button
                                          onClick={() => this.Openpopup(item.id, item.contact_count, item.delivered, item.failed, item.sent, item.read, item.optout, item.other)}
                                          style={{
                                            padding: "2px 8px",
                                            fontSize: "11px",
                                            borderRadius: "12px",
                                            border: "none",
                                            backgroundColor: "#ffc107",
                                            cursor: "pointer",
                                            fontWeight: "500",
                                            marginLeft: "5px",
                                            color: "white"
                                          }}
                                        >
                                          Insights
                                        </button>
                                      )}

                                      <small style={{ color: "black" }}>
                                        Campaign Cost: {" "}
                                        <span style={{ color: "#4c0af5" }}>{(this.state.channel === "rcs" || this.state.channel === "all") && item._id ? parseFloat(item.block_cr).toFixed(2) : parseFloat(item.campaign_cost).toFixed(2)}</span>
                                      </small>
                                    </div>
                                    {item.is_fallback === 1 && (
                                      (
                                        (this.state.channel === "rcs" || this.state.channel === "all") &&
                                        item._id
                                      ) ||
                                      (
                                        (this.state.channel === "whatsapp" || this.state.channel === "all") &&
                                        item.campaign_type === "whatsapp"
                                      )
                                    ) ?
                                      <>
                                        <div className="mt-3">

                                          {Object.keys(item?.fallback_condition || {}).map((x, index) => {

                                            const fb = item.fallback_condition[x];
                                            const fallbackData = fb.FallbackData || null;
                                            const accordionKey = `${item.id || item._id}-${x}`;
                                            const isOpen = this.state.openAccordion.includes(accordionKey);

                                            // console.log(fb);


                                            return (
                                              <div className="card mb-2 shadow-sm" key={x}>

                                                {/* ===== FALLBACK HEADER ===== */}
                                                <div
                                                  className="card-header d-flex justify-content-between align-items-center"
                                                  style={{ cursor: "pointer" }}
                                                  onClick={() => this.toggleAccordion(item._id, item.id, x, fb.channel)}
                                                >
                                                  <div>
                                                    <span className={fb.channel === "sms" ? "badge bg-success me-2" : "badge bg-primary me-2"}>
                                                      Fallback {index + 1}
                                                    </span>

                                                    <span className="text-muted ml-3">
                                                      Channel:
                                                      <b className="ms-1">
                                                        {fb.channel === "whatsapp" ? "WhatsApp" : fb.channel === "sms" ? "SMS" : fb.channel === "rcs" ? "RCS" : ""}
                                                      </b>
                                                    </span>
                                                  </div>

                                                  <span className="text-muted">
                                                    {isOpen ? "▲" : "▼"}
                                                  </span>
                                                </div>

                                                {/* ===== FALLBACK BODY ===== */}
                                                {isOpen && (
                                                  <div className="card-body">

                                                    {/* STATS GRID */}
                                                    <div className="row text-center gy-3">

                                                      <div className="col-6 col-md">
                                                        <small className="text-muted">Total</small>
                                                        <div className="fw-bold">{fallbackData?.contact_count || 0}</div>
                                                      </div>

                                                      <div className="col-6 col-md">
                                                        <small className="text-muted">Delivered</small>
                                                        <div className="fw-bold">{fallbackData?.delivered || 0}</div>
                                                      </div>

                                                      <div className="col-6 col-md">
                                                        <small className="text-muted">Failed</small>
                                                        <div className="fw-bold">{fallbackData?.failed || 0}</div>
                                                      </div>

                                                      {fb.channel === "whatsapp" && (
                                                        <>
                                                          <div className="col-6 col-md">
                                                            <small className="text-muted">Sent</small>
                                                            <div className="fw-bold">{fallbackData?.sent || 0}</div>
                                                          </div>

                                                          <div className="col-6 col-md">
                                                            <small className="text-muted">Read</small>
                                                            <div className="fw-bold">{fallbackData?.read || 0}</div>
                                                          </div>
                                                        </>
                                                      )}

                                                      <div className="col-6 col-md">
                                                        <small className="text-muted">Opt Out</small>
                                                        <div className="fw-bold">{fallbackData?.optout || 0}</div>
                                                      </div>

                                                      {fb.channel === "sms" && (
                                                        <>
                                                          <div className="col-6 col-md">
                                                            <small className="text-muted">DND</small>
                                                            <div className="fw-bold">{fallbackData?.dnd || 0}</div>
                                                          </div>

                                                          <div className="col-6 col-md">
                                                            <small className="text-muted">Other</small>
                                                            <div className="fw-bold">{fallbackData?.other || 0}</div>
                                                          </div>
                                                        </>
                                                      )}
                                                    </div>

                                                    {fallbackData &&
                                                      <>
                                                        <hr />


                                                        <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">

                                                          <small>
                                                            Campaign ID:
                                                            <b className="ms-1">{fallbackData?.id}</b>
                                                            <span className="mx-1">|</span>
                                                            Cost:
                                                            <b className={fb.channel === "sms" ? "ms-1 text-primary" : "ms-1 text-success"}>
                                                              {parseFloat(fallbackData?.campaign_cost || 0).toFixed(2)}
                                                            </b>
                                                          </small>

                                                          <div className="d-flex gap-3">
                                                            {/* ===== REPORT LINK ===== */}
                                                            <Link
                                                              to={
                                                                fb.channel === "whatsapp"
                                                                  ? `/admin/campaign-report/${fallbackData?.user_id}/${fallbackData?.id}/${fallbackData?.user_name}/${fallbackData?.contact_count}`
                                                                  : `/dashboard/campaign/detailed-report/${fallbackData?.campaign_type}/${fallbackData?.id}/${fallbackData?.campaign_name}/${fallbackData?.contact_count}`
                                                              }
                                                              target="_blank"
                                                              rel="noopener noreferrer"
                                                              className={fb.channel === "whatsapp" ? "text-success mr-2" : "text-primary mr-2"}
                                                            >
                                                              <FontAwesomeIcon icon={faEye} /> Report
                                                            </Link>

                                                            {/* ===== DOWNLOAD LINK ===== */}
                                                            {fallbackData.archive_status === 0 &&
                                                              this.state.encryptData?.whatsapp === 0 && (
                                                                <a
                                                                  href={`${HOST_URL}/bulk_campaign.php?user_id=${fallbackData?.user_id}&method=download&campaign_id=${fallbackData?.id}&channel=whatsapp&token=${this.state.token}`}
                                                                  className="text-success"
                                                                >
                                                                  <FontAwesomeIcon icon={faDownload} /> Download
                                                                </a>
                                                              )}

                                                            {fallbackData.archive_status === 0 &&
                                                              this.state.encryptData?.sms === 0 && (
                                                                <a
                                                                  href={`${HOST_URL}/bulk_campaign.php?user_id=${fallbackData?.user_id}&method=download&campaign_id=${fallbackData?.id}&channel=whatsapp&token=${this.state.token}`}
                                                                  className="text-success"
                                                                >
                                                                  <FontAwesomeIcon icon={faDownload} /> Download
                                                                </a>
                                                              )}

                                                            {fallbackData.archive_status === 0 &&
                                                              this.state.encryptData?.rcs === 0 && (
                                                                <a
                                                                  href={`${HOST_URL}/bulk_campaign.php?user_id=${fallbackData?.user_id}&method=download&campaign_id=${fallbackData?.id}&channel=whatsapp&token=${this.state.token}`}
                                                                  className="text-success"
                                                                >
                                                                  <FontAwesomeIcon icon={faDownload} /> Download
                                                                </a>
                                                              )}
                                                          </div>


                                                        </div>
                                                      </>}

                                                  </div>
                                                )}

                                              </div>
                                            );
                                          })}
                                        </div>

                                      </> : null}
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}</> : null}

                      {this.state.numberFilterSearch ?
                        <>
                          {this.state.loading === true ? (
                            <Spining />
                          ) : (
                            <div className="col-md-12">
                              {this.state.numberFiltercampaignList?.length < 1 && (
                                <div className="card d-flex justify-content-center align-items-center ">
                                  <h6>No Record Found</h6>
                                </div>
                              )}
                              {this.state.numberFiltercampaignList?.map((item, i) => (
                                <div className="card" key={i}>
                                  <div className="card-body" style={{ minWidth: "300px", overflowX: "auto" }}>
                                    {/* <div className="d-flex  justify-content-between">
                                <p>
                                  {" "}
                                  {
                                    (this.state.channel === "whatsapp" || this.state.channel === "all") && item.campaign_type === "whatsapp" ?
                                      <IoLogoWhatsapp className="text-success mr-2" style={{ fontSize: '2em' }} /> : null
                                  }

                                  {
                                    (this.state.channel === "sms" || this.state.channel === "all") && item.campaign_type === "sms" ?
                                      <FaSms className="text-primary mr-2" style={{ fontSize: '2em' }} /> : null
                                  }

                                  {
                                    (this.state.channel === "rcs" || this.state.channel === "all") && item._id ?
                                      // <FaMessage className="text-primary mr-2" style={{ fontSize: '2em' }} />
                                      <img alt="Rcs Image" className="text-primary mr-2 rcs-logo-image" style={{ fontSize: '2em' }} src={RcsImage} />

                                      : null
                                  }

                                  Template ID:{" "}
                                  <span style={{ fontWeight: "bold" }}>
                                    {item.template_id}{" "}
                                  </span>{" "}
                                </p>

                                <p>Campaign Date: {dayjs(item.created_date).format("DD/MM/YYYY h:mm A")}</p>
                              </div>
                              <hr className="m-0 mb-1"></hr> */}
                                    <div className="d-flex summary-data text-center ">
                                      {this.state.channel === "whatsapp" &&
                                        <div className="mb-1">
                                          <span className="text-muted"> Mobile </span>{" "}
                                          <br />
                                          <span className="textvalue">
                                            {" "}
                                            {/* <FontAwesomeIcon
                                    icon={faArrowUp}
                                    color="green"
                                    size="1x"
                                  />{" "} */}
                                            {item.mobile}{" "}
                                          </span>{" "}
                                        </div>}

                                      {this.state.channel === "rcs" || this.state.channel === "sms" ?
                                        <div className="mb-1">
                                          <span className="text-muted"> Campaign ID </span>{" "}
                                          <br />
                                          <span className="textvalue">
                                            {" "}
                                            {/* <FontAwesomeIcon
                                    icon={faArrowUp}
                                    color="green"
                                    size="1x"
                                  />{" "} */}
                                            {item.campaign_id}{" "}
                                          </span>{" "}
                                        </div> : null}

                                      {this.state.channel === "whatsapp" &&
                                        <div className="mb-1">
                                          <span className="text-muted">
                                            {" "}
                                            Template Type{" "}
                                          </span>{" "}
                                          <br />
                                          <span className="textvalue">
                                            {" "}
                                            {/* <FontAwesomeIcon
                                    icon={faArrowUp}
                                    color="green"
                                    size="1x"
                                  />{" "} */}
                                            {item.message_type === 1 ? <span>Marketing</span> : item.message_type === 2 ? <span>Utility</span> : item.message_type === 3 ? <span>Authentication</span> : null}{" "}
                                          </span>{" "}
                                        </div>}

                                      {this.state.channel === "rcs" || this.state.channel === "sms" ?
                                        <div className="mb-1">
                                          <span className="text-muted" style={{ fontSize: "12px" }}>
                                            {" "}
                                            Country Code{" "}
                                          </span>{" "}
                                          <br />
                                          <span className="textvalue">
                                            {" "}
                                            {/* <FontAwesomeIcon
                                    icon={faArrowUp}
                                    color="green"
                                    size="1x"
                                  />{" "} */}
                                            {item.country_code}{" "}
                                          </span>{" "}
                                        </div> : null}

                                      {this.state.channel === "rcs" || this.state.channel === "sms" ?
                                        <div className="mb-1">
                                          <span className="text-muted">
                                            {" "}
                                            Campaign Message{" "}
                                          </span>{" "}
                                          <br />
                                          <span className="textvalue" style={{ fontSize: "10px" }}>
                                            {" "}
                                            {/* <FontAwesomeIcon
                                    icon={faArrowUp}
                                    color="green"
                                    size="1x"
                                  />{" "} */}
                                            {item.campaign_message}{" "}
                                          </span>{" "}
                                        </div> : null}

                                      <div className="mb-1">
                                        <span className="text-muted"> Status </span>
                                        <br />{" "}
                                        <span className="textvalue">
                                          {" "}
                                          {/* <FontAwesomeIcon
                                    icon={faArrowDown}
                                    color="red"
                                    size="1x"
                                  />{" "} */}
                                          {item.status}{" "}
                                        </span>{" "}
                                      </div>

                                      {this.state.channel === "rcs" || this.state.channel === "sms" ?
                                        <div className="mb-1">
                                          <span className="text-muted">
                                            {" "}
                                            Sent Time{" "}
                                          </span>{" "}
                                          <br />
                                          <span className="textvalue">
                                            {" "}
                                            {/* <FontAwesomeIcon
                                    icon={faArrowUp}
                                    color="green"
                                    size="1x"
                                  />{" "} */}
                                            {item.sent_time}{" "}
                                          </span>{" "}
                                        </div> : null}

                                      <div className="mb-1">
                                        <span className="text-muted"> Deliver Time </span>{" "}
                                        <br />
                                        <span className="textvalue">
                                          {" "}
                                          {/* <FontAwesomeIcon
                                            icon={faArrowUp}
                                            color="green"
                                            size="1x"
                                          /> */}
                                          {" "}
                                          {item.deliver_time}{" "}
                                        </span>{" "}
                                      </div>

                                      {this.state.channel === "whatsapp" &&
                                        <div className="mb-1">
                                          <span className="text-muted"> Session Time </span>
                                          <br />{" "}
                                          <span className="textvalue">
                                            {" "}
                                            {/* <FontAwesomeIcon
                                            icon={faArrowUp}
                                            color="green"
                                            size="1x"
                                          /> */}
                                            {" "}
                                            {item.n24htime}{" "}
                                          </span>{" "}
                                        </div>}

                                      {this.state.channel === "rcs" || this.state.channel === "sms" ?
                                        <div className="mb-1">
                                          <span className="text-muted"> API Status </span>
                                          <br />{" "}
                                          <span className="textvalue">
                                            {" "}
                                            {/* <FontAwesomeIcon
                                            icon={faArrowUp}
                                            color="green"
                                            size="1x"
                                          /> */}
                                            {" "}
                                            {item.api_status}{" "}
                                          </span>{" "}
                                        </div> : null}

                                      {this.state.channel === "rcs" || this.state.channel === "sms" ?
                                        <div className="mb-1">
                                          <span className="text-muted"> API Response </span>
                                          <br />{" "}
                                          <span className="textvalue">
                                            {" "}
                                            {/* <FontAwesomeIcon
                                            icon={faArrowUp}
                                            color="green"
                                            size="1x"
                                          /> */}
                                            {" "}
                                            {item.api_response}{" "}
                                          </span>{" "}
                                        </div> : null}

                                      <div className="mb-1">
                                        <span className="text-muted"> Submit Via </span>
                                        <br />{" "}
                                        <span className="textvalue">
                                          {" "}
                                          {/* <FontAwesomeIcon
                                            icon={faArrowUp}
                                            color="green"
                                            size="1x"
                                          /> */}
                                          {" "}
                                          {this.state.channel === "whatsapp" ? item.submit_via : item.submit_from}{" "}
                                        </span>{" "}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}</> : null}

                      {this.state.templateSummary &&
                        <>
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            {/* <h3 className="mt-2 ml-3">Campaign Report</h3> */}
                            <div style={{ display: 'flex', alignItems: 'center', marginRight: '20px' }}>
                              {/* <div className="input-group drop-down-icons mt-2"> */}

                              {/* </div> */}
                            </div>
                          </div>

                          <div className="card-header">
                            <div className="row">
                              <div className="col-5">
                                <label>Select Channel</label>
                                <select className="form-control" value={this.state.templateChannel} onChange={this.handleTemplateChannelChange}>
                                  <option value="">Select Channel</option>
                                  <option value="whatsapp">Whatsapp</option>
                                  <option value="sms">SMS</option>
                                </select>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-5">
                                <label>From:</label>
                                <div className="input-group mb-2 mr-sm-2">
                                  <div className="input-group-text">
                                    <FontAwesomeIcon icon={faCalendarAlt} />
                                  </div>
                                  <ReactDatePicker
                                    className="form-control btn-block"
                                    dateFormat="dd/MM/yyyy"
                                    selected={this.state.startDateTemplate}
                                    onChange={(date) => this.startDateTemplateHandler(date)}
                                    selectsStart
                                    startDate={this.state.startDateTemplate}
                                    endDate={this.state.endDateTemplate}
                                    placeholderText="Select From Date"
                                  />
                                </div>
                              </div>

                              <div className="col-5">
                                <label>To:</label>
                                <div className="input-group mb-2 mr-sm-2">
                                  <div className="input-group-text">
                                    <FontAwesomeIcon icon={faCalendarAlt} />
                                  </div>
                                  <ReactDatePicker
                                    className="form-control btn-block"
                                    dateFormat="dd/MM/yyyy"
                                    selected={this.state.endDateTemplate}
                                    onChange={(date) => this.endDateTemplateHandler(date)}
                                    selectsEnd
                                    startDate={this.state.startDateTemplate}
                                    endDate={this.state.endDateTemplate}
                                    minDate={this.state.startDateTemplate}
                                    maxDate={this.state.maxDate}
                                    placeholderText="Select To Date"
                                    disabled={!this.state.startDateTemplate} // disable until start date selected
                                  />
                                </div>
                              </div>
                              <div className="col-2">
                                {this.state.loadingBtn ? (
                                  <button className="btn btn-success float-right p-2 mr-3" type="button" disabled>
                                    <span
                                      className="spinner-border spinner-border-sm"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                    <span className="sr-only">Loading...</span>
                                  </button>
                                ) : (
                                  <button
                                    className="btn btn-success float-right p-2 mr-3 mt-4"
                                    // onClick={() => this.getCampaignList(this.state.channel)}
                                    onClick={this.state.templateChannel === "whatsapp" ? this.searchTemplateSummary : this.searchTemplateSummarySms}
                                  >
                                    <FontAwesomeIcon className="fa-lg" icon={faSearch} />
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </>}

                      {this.state.templateSummary ?
                        <>
                          {this.state.loading === true ? (
                            <Spining />
                          ) : (
                            <div className="col-md-12">
                              {Object.keys(this.state.templateSummaryList).length === 0 && (
                                <div className="card d-flex justify-content-center align-items-center ">
                                  <h6>No Record Found</h6>
                                </div>
                              )}
                              {Object.keys(this.state.templateSummaryList)?.map((item, i) => {
                                let templateData = this.state.templateSummaryList[item]
                                return (
                                  <div className="card" key={i}>
                                    <div className="card-body">
                                      <div className="d-flex  justify-content-between campaign-flex-wrap">
                                        <p>
                                          {" "}
                                          {this.state.templateChannel === "whatsapp" ? <IoLogoWhatsapp className="text-success mr-2" style={{ fontSize: '2em' }} /> : this.state.templateChannel === "sms" ? <FaSms className="text-primary mr-2" style={{ fontSize: '2em' }} /> : null}

                                          <span>Template Name:{" "}</span>
                                          <span style={{ fontWeight: "bold" }}>
                                            {templateData.name}{" "}
                                          </span>{" "}
                                        </p>
                                      </div>

                                      {/* <div className="row">
                                    <div className="d-flex justify-content-end">
                                      <p className="mb-0">
                                        <small>
                                          Campaign Date: {dayjs(item.camp_start_datetime).format("DD/MM/YYYY h:mm A")}
                                        </small>
                                      </p>
                                    </div>
                                  </div> */}

                                      <hr className="m-0 mb-1"></hr>
                                      <div className="d-flex flex-wrap summary-data text-center">
                                        <div className="summary-item mb-1">
                                          <span className="text-muted label">
                                            {" "}
                                            Delivered{" "}
                                          </span>{" "}
                                          <br />
                                          <span className="textvalue text-success value">
                                            {" "}
                                            {templateData.delivered}{" "}
                                          </span>{" "}
                                        </div>

                                        <div className="summary-item mb-1">
                                          <span className="text-muted label"> Failed </span>
                                          <br />{" "}
                                          <span className="textvalue text-success value">
                                            {" "}
                                            {templateData.fail_count}{" "}
                                          </span>{" "}
                                        </div>

                                        {this.state.templateChannel === "whatsapp" &&
                                          <>
                                            <div className="summary-item mb-1">
                                              <span className="text-muted label"> Sent </span>
                                              <br />{" "}
                                              <span className="textvalue text-success value">
                                                {" "}
                                                {templateData.sent_count}{" "}
                                              </span>{" "}
                                            </div>

                                            <div className="summary-item mb-1">
                                              <span className="text-muted label"> Read </span>
                                              <br />{" "}
                                              <span className="textvalue text-success value">
                                                {" "}
                                                {templateData.readcount}{" "}
                                              </span>{" "}
                                            </div>
                                          </>}

                                        {this.state.templateChannel === "sms" &&
                                          <>
                                            <div className="summary-item mb-1">
                                              <span className="text-muted label"> DND </span>
                                              <br />{" "}
                                              <span className="textvalue text-success value">
                                                {" "}
                                                {templateData.dnd_count}{" "}
                                              </span>{" "}
                                            </div>
                                          </>}

                                        {this.state.templateChannel === "whatsapp" &&
                                          <div className="summary-item mb-1">
                                            <span className="text-muted label"> Optout </span>
                                            <br />{" "}
                                            <span className="textvalue text-success value">
                                              {" "}
                                              {templateData.optout_count}{" "}
                                            </span>{" "}
                                          </div>}

                                        <div className="summary-item mb-1">
                                          <span className="text-muted label"> other </span>
                                          <br />{" "}
                                          <span className="textvalue text-success value">
                                            {" "}
                                            {templateData.other_count}{" "}
                                          </span>{" "}
                                        </div>

                                      </div>
                                      <div className="d-flex justify-content-between mt-1">
                                        <div className="d-flex">
                                          <small className="m-0, p-0">
                                            <span style={{ color: "black" }}>Template ID:</span> <span style={{ color: "#4c0af5" }}>{item}</span><span style={{ color: "black" }}>/</span>
                                          </small>
                                          {this.state.templateChannel === "whatsapp" &&
                                            <small className="m-0, p-0">
                                              <span style={{ color: "black" }}>Template Type:</span> <span style={{ color: "#4c0af5" }}>{templateData.template_type === "1" ? <span>Marketing</span> : templateData.template_type === "2" ? <span>Utility</span> : templateData.template_type === "3" ? <span>Authentication</span> : null}</span><span style={{ color: "black" }}></span>
                                            </small>}
                                          {/* {this.state.channel === "sms" ? <small>Template ID:  xxxxxxxx{item?.template_id?.substr(-4,4)}/</small> :
                                  <small>Template ID: {item?.template_id}/</small>} */}
                                        </div>

                                      </div>
                                    </div>
                                  </div>
                                )

                              })}
                            </div>
                          )}</> : null}

                      {this.state.daywisesummary &&
                        <>
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            {/* <h3 className="mt-2 ml-3">Campaign Report</h3> */}
                            <div style={{ display: 'flex', alignItems: 'center', marginRight: '20px' }}>
                              {/* <div className="input-group drop-down-icons mt-2"> */}

                              {/* </div> */}
                            </div>
                          </div>

                          {this.state.successDaywiseShow ? (
                            <div className={this.state.bgColorDaywise} role="alert">
                              <button
                                type="button"
                                className="close"
                                data-dismiss="alert"
                                aria-label="Close"
                              >
                                <span aria-hidden="true">×</span>
                              </button>
                              <div className="">{this.state.successdaywiseMessage}</div>
                            </div>
                          ) : null}

                          <div className="card-header">
                            <div className="row">
                              <div className="col-5">
                                <label>Select Channel</label>
                                <select className="form-control" value={this.state.daywiseChannel} onChange={this.handleDayWiseChannelChange}>
                                  <option value="">Select Channel</option>
                                  <option value="whatsapp">Whatsapp</option>
                                  <option value="sms">SMS</option>
                                </select>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-5">
                                <label>From:</label>
                                <div className="input-group mb-2 mr-sm-2">
                                  <div className="input-group-text">
                                    <FontAwesomeIcon icon={faCalendarAlt} />
                                  </div>

                                  <ReactDatePicker
                                    className="form-control btn-block"
                                    dateFormat="dd/MM/yyyy"
                                    selected={this.state.startDatedaywise}
                                    onChange={(date) => this.startDateDaywiseHandler(date)}
                                    selectsStart
                                    startDate={this.state.startDatedaywise}
                                    endDate={this.state.endDatedaywise}
                                    placeholderText="Select From Date"
                                  />
                                </div>
                              </div>

                              <div className="col-5">
                                <label>To:</label>
                                <div className="input-group mb-2 mr-sm-2">
                                  <div className="input-group-text">
                                    <FontAwesomeIcon icon={faCalendarAlt} />
                                  </div>

                                  <ReactDatePicker
                                    className="form-control btn-block"
                                    dateFormat="dd/MM/yyyy"
                                    selected={this.state.endDatedaywise}
                                    onChange={(date) => this.endDateDaywiseHandler(date)}
                                    selectsEnd
                                    startDate={this.state.startDatedaywise}
                                    endDate={this.state.endDatedaywise}
                                    minDate={this.state.startDatedaywise}
                                    maxDate={this.state.maxDate}
                                    placeholderText="Select To Date"
                                    disabled={!this.state.startDatedaywise} // disable until start selected
                                  />
                                </div>
                              </div>

                              <div className="col-2">
                                {this.state.loadingBtn ? (
                                  <button className="btn btn-success float-right p-2 mr-3" type="button" disabled>
                                    <span
                                      className="spinner-border spinner-border-sm"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                    <span className="sr-only">Loading...</span>
                                  </button>
                                ) : (
                                  <button
                                    className="btn btn-success float-right p-2 mr-3 mt-4"
                                    // onClick={() => this.getCampaignList(this.state.channel)}
                                    onClick={this.state.daywiseChannel === "whatsapp" ? this.DayWiseSummaryReportWhatsapp : this.DayWiseSummaryReportSms}
                                  >
                                    <FontAwesomeIcon className="fa-lg" icon={faSearch} />
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </>}

                      {this.state.daywisesummary ?
                        <>
                          {this.state.loading === true ? (
                            <Spining />
                          ) : (
                            <div className="table-responsive mt-4">
                              {this.state.daywiseSummaryList && Object.keys(this.state.daywiseSummaryList).length > 0 ? (
                                <table className="table table-striped table-hover align-middle text-center">
                                  <thead className="table-light">
                                    <tr>
                                      <th scope="col">Date</th>
                                      <th scope="col">Total</th>
                                      <th scope="col">Delivered</th>
                                      <th scope="col">Failed</th>
                                      {this.state.daywiseChannel === "whatsapp" &&
                                        <>
                                          <th scope="col">Sent</th>
                                          <th scope="col">Read</th>
                                          <th scope="col">Optout</th>
                                        </>}
                                      {this.state.daywiseChannel === "sms" &&
                                        <th scope="col">DND</th>}
                                      <th scope="col">Other</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {Object.keys(this.state.daywiseSummaryList).map((item, index) => {
                                      const summaryData = this.state.daywiseSummaryList[item];
                                      return (
                                        <tr key={index}>
                                          <td>{item}</td>
                                          {this.state.daywiseChannel === "whatsapp" ?
                                            <td>{parseInt(summaryData.delivered) + parseInt(summaryData.fail_count) + parseInt(summaryData.sent_count) + parseInt(summaryData.readcount) + parseInt(summaryData.optout_count) + parseInt(summaryData.other_count)}</td> :
                                            <td>{parseInt(summaryData.delivered) + parseInt(summaryData.fail_count) + parseInt(summaryData.dnd_count) + parseInt(summaryData.other_count)}</td>}
                                          <td>{summaryData.delivered}</td>
                                          <td>{summaryData.fail_count}</td>
                                          {this.state.daywiseChannel === "whatsapp" &&
                                            <><td>{summaryData.sent_count}</td>
                                              <td>{summaryData.readcount}</td>
                                              <td>{summaryData.optout_count}</td>
                                            </>}
                                          {this.state.daywiseChannel === "sms" &&
                                            <td>{summaryData.dnd_count}</td>}
                                          <td>{summaryData.other_count}</td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              ) : (
                                <div className="text-center py-4 text-muted border rounded">
                                  <h6>No Record Found</h6>
                                </div>
                              )}
                            </div>
                          )}</> : null}
                      <WhatsAppCampaignListPreview templateDetails={this.state.templateDetails} openTemplatePopup={this.state.openTemplatePopup} closePopup={this.closePopup} />

                      {/* <AdvanceDataTable
                      tableName={""}
                      tableCell={WHATSAPP_CAMPAIGN_LIST_CONST}
                      tableData={this.state.campaignList}
                      isLoading={this.state.loading}
                      isError={this.state.ErrorResponse}
                    /> */}

                      {/* {this.state.campaignList ? (
                      <table className="table table-hover text-left  project  my-0">
                        <thead>
                          <tr>
                            <th>Campaign ID</th>
                            <th>Campaign Name</th>
                            {this.state.channel === "whatsapp" && (
                              <th> Template ID </th>
                            )}
                            <th>Total Campaign Data</th>
                            <th>Campaign Start On</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.filterCampaignList.map((itam, i) => (
                            <tr key={i}>
                              <td>{itam.id}</td>
                              <td>{itam.campaign_name}</td>
                              {this.state.channel === "whatsapp" && (
                                <td>{itam.template_id}</td>
                              )}

                              <td>
                                <span className="badge bg-primary">
                                  {itam.contact_count}
                                </span>
                              </td>
                              <td> {itam.camp_start_datetime} </td>
                              <td>
                                {" "}
                                {itam.status === 1 ? (
                                  <span className="badge bg-info">
                                    Submitted
                                  </span>
                                ) : itam.status === 2 ? (
                                  <span className="badge bg-info">
                                    Schedule
                                  </span>
                                ) : itam.status === 3 ? (
                                  <span className="badge bg-success">
                                    Processing
                                  </span>
                                ) : itam.status === 5 ? (
                                  <span className="badge bg-warning">
                                    Schedule{" "}
                                  </span>
                                ) : (
                                  <span className="badge bg-primary ">
                                    Completed
                                  </span>
                                )}{" "}
                              </td>
                              <td>
                                {itam.status === 5 ? null : (
                                  <a
                                    href={`/dashboard/campaign/summary-report/${
                                      this.state.channel
                                    }/${itam.id}/${encodeURIComponent(
                                      itam.campaign_name
                                    )}`}
                                  >
                                    <span className="badge bg-success">
                                      {" "}
                                      <FontAwesomeIcon
                                        icon={faEye}
                                      /> Report{" "}
                                    </span>
                                  </a>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : (
                      <div className="text-center pb-5">
                        <div className="card-body">
                          <img
                            alt="Empty Data"
                            className="project-empty-img"
                            src={EmptyImg}
                          />
                          <p>No Campaign Yet</p>
                          <Link
                            className="btn  btn-success btn-sm"
                            to="/dashboard/campaign-start"
                          >
                            Create New Campaign
                          </Link>
                        </div>
                      </div>
                    )} */}
                    </div>

                    {this.state.openReschedulePopup && (
                      <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: 'block' }} aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog" role="document">
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5 className="modal-title" id="exampleModalLabel">Reschedule Campaign</h5>
                              <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => this.setState({ openReschedulePopup: false })}>
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <div className="modal-body">
                              <div className="container">
                                <div className="row">
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label htmlFor="textField1">Campaign ID</label>
                                      <input type="text" value={this.state.rescheduleid} className="form-control" id="textField1" disabled={true} placeholder="Enter text" />
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label htmlFor="textField2">Campaign Name</label>
                                      <input type="text" value={this.state.rescheduleName} disabled={true} className="form-control" id="textField2" placeholder="Enter text" />
                                    </div>
                                  </div>
                                  <div className="col-md-12">
                                    <div className="form-group">
                                      <label htmlFor="datePicker">Select Date</label>
                                      <div className="input-group">
                                        <div className="input-group-text">
                                          <FontAwesomeIcon icon={faAddressBook} />
                                        </div>
                                        <input
                                          type="datetime-local"
                                          className="form-control"
                                          value={this.state.selectedDate}
                                          onChange={this.handleChange}
                                          min={this.state.selectedDate}
                                          max={this.state.selectedDate ? this.getMaxDate() : ''}
                                          placeholder="Example: Date For Reschedule Campaign"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="modal-footer">
                              <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={() => this.setState({ openReschedulePopup: false })}>
                                Close
                              </button>
                              <button type="button" className="btn btn-primary" onClick={this.rescheduleCampaign}>Save Changes</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {this.state.deletePopup && (
                      <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: 'block' }} aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog" role="document">
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5 className="modal-title" id="exampleModalLabel">{this.state.deleteCampaignName}</h5>
                              <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => this.setState({ deletePopup: false })}>
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <div className="modal-body">
                              <h6 style={{ color: "red" }}>Are You Sure you Want to Delete <b style={{ color: "black" }}>{this.state.deleteCampaignName}</b> Campaign .</h6>
                            </div>
                            <div className="modal-footer">
                              <button type="button" className="btn btn-info" data-dismiss="modal" onClick={() => this.setState({ deletePopup: false })}>
                                No
                              </button>
                              <button type="button" className="btn btn-danger" onClick={() => this.Deletecampaign()}>Yes</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {this.state.deleteWhatsappPopup && (
                      <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: 'block' }} aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog" role="document">
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5 className="modal-title" id="exampleModalLabel">{this.state.deleteCampaignName}</h5>
                              <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => this.setState({ deleteWhatsappPopup: false })}>
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <div className="modal-body">
                              <h6 style={{ color: "red" }}>Are You Sure you Want to Delete <b style={{ color: "black" }}>{this.state.deleteWhatsappCampaignName}</b> Campaign .</h6>
                            </div>
                            <div className="modal-footer">
                              <button type="button" className="btn btn-info" data-dismiss="modal" onClick={() => this.setState({ deleteWhatsappPopup: false })}>
                                No
                              </button>
                              {(this.state.channel === "sms" || this.state.channel === "all") && this.state.campaignType === "sms" ?
                                <button type="button" className="btn btn-danger" onClick={() => this.DeleteSmsCampaignList()}>Yes</button> :
                                (this.state.channel === "whatsapp" || this.state.channel === "all") && this.state.campaignType === "whatsapp" ?
                                  <button type="button" className="btn btn-danger" onClick={() => this.DeletecampaignList()}>Yes</button> :
                                  null
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    )}


                    {/* 💬 WhatsApp Summary Modal */}
                    {this.state.whatsappFullDetails && (
                      <div
                        className="popup-overlay d-flex justify-content-center align-items-center"
                        style={{
                          position: "fixed",
                          top: 0,
                          left: 0,
                          width: "100vw",
                          height: "100vh",
                          backgroundColor: "rgba(0, 0, 0, 0.5)",
                          zIndex: 1050,
                        }}
                      >
                        <div className="popup-card col-10 col-sm-8 col-md-6 col-lg-4">
                          <div className="card shadow-lg border-0" style={{ borderRadius: "10px" }}>
                            <div className="card-body p-4">
                              {/* Header with Close Button */}
                              <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5 className="card-title text-success mb-0">Total WhatsApp Submission : {this.state.whatsappUtilitySubmission + this.state.whatsappMarketingSubmission + this.state.whatsappAuthnSubmission}</h5>
                                <button
                                  type="button"
                                  className="btn btn-outline-danger btn-sm rounded-circle d-flex justify-content-center align-items-center"
                                  style={{ width: "30px", height: "30px" }}
                                  onClick={() => this.setState({ whatsappFullDetails: false })}
                                >
                                  &times;
                                </button>
                              </div>

                              {/* <h6 className="mb-3 text-success fw-bold text-end">
                              {this.state.totalWhatsapp || 0}
                            </h6> */}

                              <div className="row">
                                {/* Utility Column */}
                                <div className="col-4">
                                  <h6 style={{ fontSize: "12px" }} className="text-muted text-center"><b>Utility</b></h6>
                                  <ul className="list-unstyled text-muted small">
                                    <li style={{ fontSize: "10px" }}><strong>Total Count:</strong> {this.state.whatsappUtilitySubmission || 0}</li>
                                    <li style={{ fontSize: "10px" }}><strong>Delivered:</strong> {this.state.whatsappUtilityDelivered || 0}</li>
                                    <li style={{ fontSize: "10px" }}><strong>Sent:</strong> {this.state.whatsappUtilitySent || 0}</li>
                                    <li style={{ fontSize: "10px" }}><strong>Read:</strong> {this.state.whatsappUtilityRead || 0}</li>
                                    <li style={{ fontSize: "10px" }}><strong>Failed:</strong> {this.state.whatsappUtilityFailed || 0}</li>
                                    <li style={{ fontSize: "10px" }}><strong>Other:</strong> {this.state.whatsappUtilityOther || 0}</li>
                                    <li style={{ fontSize: "10px" }}><strong>Optout:</strong> {this.state.whatsappUtilityOptout || 0}</li>
                                    <li style={{ fontSize: "10px" }}><strong>Total Cost:</strong> {this.state.whatsappUtilityCost || 0}</li>
                                  </ul>
                                </div>

                                {/* Marketing Column */}
                                <div className="col-4">
                                  <h6 style={{ fontSize: "12px" }} className="text-muted text-center"><b>Marketing</b></h6>
                                  <ul className="list-unstyled text-muted small">
                                    <li style={{ fontSize: "10px" }}><strong>Total Count:</strong> {this.state.whatsappMarketingSubmission || 0}</li>
                                    <li style={{ fontSize: "10px" }}><strong>Delivered:</strong> {this.state.whatsappMarketingDelivered || 0}</li>
                                    <li style={{ fontSize: "10px" }}><strong>Sent:</strong> {this.state.whatsappMarketingSent || 0}</li>
                                    <li style={{ fontSize: "10px" }}><strong>Read:</strong> {this.state.whatsappMarketingRead || 0}</li>
                                    <li style={{ fontSize: "10px" }}><strong>Failed:</strong> {this.state.whatsappMarketingFailed || 0}</li>
                                    <li style={{ fontSize: "10px" }}><strong>Other:</strong> {this.state.whatsappMarketingOther || 0}</li>
                                    <li style={{ fontSize: "10px" }}><strong>Optout:</strong> {this.state.whatsappMarketingOptout || 0}</li>
                                    <li style={{ fontSize: "10px" }}><strong>Total Cost:</strong> {this.state.whatsappMarketingCost || 0}</li>
                                  </ul>
                                </div>

                                {/* Authentication Column */}
                                <div className="col-4">
                                  <h6 style={{ fontSize: "12px" }} className="text-muted text-center"><b>Authentication</b></h6>
                                  <ul className="list-unstyled text-muted small">
                                    <li style={{ fontSize: "10px" }}><strong>Total Count:</strong> {this.state.whatsappAuthnSubmission || 0}</li>
                                    <li style={{ fontSize: "10px" }}><strong>Delivered:</strong> {this.state.whatsappAuthnDelivered || 0}</li>
                                    <li style={{ fontSize: "10px" }}><strong>Sent:</strong> {this.state.whatsappAuthnSent || 0}</li>
                                    <li style={{ fontSize: "10px" }}><strong>Read:</strong> {this.state.whatsappAuthnRead || 0}</li>
                                    <li style={{ fontSize: "10px" }}><strong>Failed:</strong> {this.state.whatsappAuthnFailed || 0}</li>
                                    <li style={{ fontSize: "10px" }}><strong>Other:</strong> {this.state.whatsappAuthnOther || 0}</li>
                                    <li style={{ fontSize: "10px" }}><strong>Optout:</strong> {this.state.whatsappAuthnOptout || 0}</li>
                                    <li style={{ fontSize: "10px" }}><strong>Total Cost:</strong> {this.state.whatsappAuthnCost || 0}</li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}






                  </div>
                </div>
              </div>
            </main>
            {this.state.openInsightPopup && (
              <div className="insight-overlay" style={{
                position: "fixed",
                top: 0, left: 0, right: 0, bottom: 0,
                backgroundColor: "rgba(15, 23, 42, 0.4)",
                backdropFilter: "blur(8px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 1000,
                animation: "fadeIn 0.2s ease-out"
              }}>
                <div className="insight-popup" style={{
                  position: "relative",
                  backgroundColor: "#ffffff",
                  borderRadius: "20px",
                  boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.05)",
                  width: "95%",
                  maxWidth: "1100px",
                  height: "85vh",
                  maxHeight: "800px",
                  display: "flex",
                  flexDirection: "row", // Horizontal splits allow for side-by-side view
                  overflow: "hidden",
                  fontFamily: "Inter, system-ui, -apple-system, sans-serif"
                }}>

                  {/* ================= LEFT MAIN PANEL ================= */}
                  <div style={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                    padding: "32px",
                    overflowY: "auto",
                    transition: "all 0.3s ease"
                  }}>

                    {/* Header Block */}
                    <div style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      marginBottom: "28px"
                    }}>
                      <div>
                        <span style={{
                          fontSize: "11px",
                          textTransform: "uppercase",
                          letterSpacing: "1.5px",
                          color: "#6366f1",
                          fontWeight: "700"
                        }}>
                          Campaign Performance
                        </span>
                        <h2 style={{
                          fontSize: "22px",
                          fontWeight: "800",
                          color: "#0f172a",
                          margin: "4px 0 0 0",
                          letterSpacing: "-0.5px"
                        }}>
                          ID: <span style={{ color: "#4f46e5" }}>{this.state.insight_template_id}</span>
                        </h2>
                      </div>

                      {/* Close main popup */}
                      <button
                        onClick={() => this.setState({ openInsightPopup: false, insightDataSummary: [], insightDataDetails: [], InsightDetailsShow: false })}
                        style={{
                          background: "#f1f5f9",
                          border: "none",
                          color: "#64748b",
                          borderRadius: "50%",
                          width: "36px",
                          height: "36px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          transition: "all 0.2s"
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = "#e2e8f0";
                          e.currentTarget.style.color = "#0f172a";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = "#f1f5f9";
                          e.currentTarget.style.color = "#64748b";
                        }}
                      >
                        <FontAwesomeIcon icon={faTimes} />
                      </button>
                    </div>

                    {/* Global Loading Spinner */}
                    {/* {(this.state.insightLoading && this.state.insightDataSummary.length === 0) && (
                      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flex: 1 }}>
                        <Spining />
                      </div>
                    )} */}

                    {/* ================= STATS GRID (Replaced ugly raw table) ================= */}
                    <div style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(auto-fit, minmax(110px, 1fr))",
                      gap: "12px",
                      marginBottom: "32px"
                    }}>
                      {[
                        { label: "Total Sent", value: this.state.InsightTotal, color: "#4f46e5", bg: "#f5f3ff" },
                        { label: "Delivered", value: this.state.InsightDelivered, color: "#16a34a", bg: "#f0fdf4" },
                        { label: "Failed", value: this.state.InsightFailed, color: "#dc2626", bg: "#fef2f2" },
                        { label: "Sent Status", value: this.state.InsightSent, color: "#2563eb", bg: "#eff6ff" },
                        { label: "Read Rate", value: this.state.InsightRead, color: "#0d9488", bg: "#f0fdfa" },
                        { label: "Opt-Out", value: this.state.InsightOptout, color: "#ea580c", bg: "#fff7ed" },
                        { label: "Other", value: this.state.InsightOther, color: "#4b5563", bg: "#f9fafb" }
                      ].map((stat, i) => (
                        <div key={i} style={{
                          background: stat.bg,
                          padding: "16px",
                          borderRadius: "14px",
                          border: "1px solid rgba(0,0,0,0.02)",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between"
                        }}>
                          <span style={{ fontSize: "11px", fontWeight: "600", color: "#64748b", textTransform: "uppercase" }}>{stat.label}</span>
                          <span style={{ fontSize: "20px", fontWeight: "800", color: stat.color, marginTop: "8px" }}>{stat.value || 0}</span>
                        </div>
                      ))}
                    </div>

                    {/* ================= BUTTONS ANALYTICS SECTION ================= */}
                    {Object.keys(this.state.insightDataSummary).length > 0 && (
                      <div style={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }}>
                        <h3 style={{ fontSize: "16px", fontWeight: "700", color: "#0f172a", marginBottom: "16px" }}>
                          Interactive Button Performance
                        </h3>

                        <div style={{
                          flex: 1,
                          overflowY: "auto",
                          border: "1px solid #f1f5f9",
                          borderRadius: "12px",
                          boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.02)"
                        }}>
                          <table style={{ width: "100%", borderCollapse: "collapse", textAlign: "left" }}>
                            <thead style={{ position: "sticky", top: 0, background: "#f8fafc", zIndex: 2 }}>
                              <tr style={{ borderBottom: "1px solid #e2e8f0" }}>
                                <th style={{ padding: "14px 20px", fontSize: "11px", fontWeight: "700", color: "#64748b", textTransform: "uppercase" }}>Button Name</th>
                                <th style={{ padding: "14px 20px", fontSize: "11px", fontWeight: "700", color: "#64748b", textTransform: "uppercase" }}>Interaction Volume</th>
                                <th style={{ padding: "14px 20px", fontSize: "11px", fontWeight: "700", color: "#64748b", textTransform: "uppercase", textAlign: "right" }}>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {(this.state.insightDataSummary.btn_summary ?? []).map((x, xi) => {
                                const isSelected = this.state.InsightDetailsShow && this.state.activeInsightBtnName === x._id;
                                return (
                                  <tr key={xi} style={{
                                    borderBottom: "1px solid #f1f5f9",
                                    background: isSelected ? "#f5f3ff" : "transparent",
                                    transition: "background 0.2s"
                                  }}>
                                    <td style={{ padding: "16px 20px", fontSize: "14px", fontWeight: "600", color: isSelected ? "#4f46e5" : "#334155" }}>
                                      {x.btn_name}
                                    </td>
                                    <td style={{ padding: "16px 20px" }}>
                                      <span style={{
                                        background: isSelected ? "#c7d2fe" : "#f1f5f9",
                                        color: isSelected ? "#312e81" : "#475569",
                                        padding: "4px 10px",
                                        borderRadius: "100px",
                                        fontSize: "12px",
                                        fontWeight: "600"
                                      }}>
                                        {x.total_clicks} Clicks
                                      </span>
                                    </td>
                                    <td style={{ padding: "16px 20px", textAlign: "right" }}>
                                      <button
                                        onClick={() => this.InsightDataDetails(x.btn_name)}
                                        style={{
                                          border: "none",
                                          background: isSelected ? "#4f46e5" : "#f8fafc",
                                          color: isSelected ? "#fff" : "#4f46e5",
                                          padding: "8px 14px",
                                          borderRadius: "8px",
                                          fontSize: "12px",
                                          fontWeight: "600",
                                          cursor: "pointer",
                                          display: "inline-flex",
                                          alignItems: "center",
                                          gap: "6px",
                                          boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                                          transition: "all 0.2s"
                                        }}
                                        onMouseEnter={(e) => {
                                          if (!isSelected) {
                                            e.currentTarget.style.background = "#eef2ff";
                                          }
                                        }}
                                        onMouseLeave={(e) => {
                                          if (!isSelected) {
                                            e.currentTarget.style.background = "#f8fafc";
                                          }
                                        }}
                                      >
                                        Analyze Details <FontAwesomeIcon icon={faEye} />
                                      </button>
                                    </td>
                                  </tr>
                                );
                              })}
                              {(this.state.insightDataSummary.cta_summary ?? []).map((x, xi) => {
                                const isSelected = this.state.InsightDetailsShow && this.state.activeInsightBtnName === x._id;
                                return (
                                  <tr key={xi} style={{
                                    borderBottom: "1px solid #f1f5f9",
                                    background: isSelected ? "#f5f3ff" : "transparent",
                                    transition: "background 0.2s"
                                  }}>
                                    <td style={{ padding: "16px 20px", fontSize: "14px", fontWeight: "600", color: isSelected ? "#4f46e5" : "#334155" }}>
                                      {x.btn_name}
                                    </td>
                                    <td style={{ padding: "16px 20px" }}>
                                      <span style={{
                                        background: isSelected ? "#c7d2fe" : "#f1f5f9",
                                        color: isSelected ? "#312e81" : "#475569",
                                        padding: "4px 10px",
                                        borderRadius: "100px",
                                        fontSize: "12px",
                                        fontWeight: "600"
                                      }}>
                                        {x.total_clicks} Clicks
                                      </span>
                                    </td>
                                    <td style={{ padding: "16px 20px", textAlign: "right" }}>
                                      <button
                                        onClick={() => this.InsightDataDetails(x.btn_name)}
                                        style={{
                                          border: "none",
                                          background: isSelected ? "#4f46e5" : "#f8fafc",
                                          color: isSelected ? "#fff" : "#4f46e5",
                                          padding: "8px 14px",
                                          borderRadius: "8px",
                                          fontSize: "12px",
                                          fontWeight: "600",
                                          cursor: "pointer",
                                          display: "inline-flex",
                                          alignItems: "center",
                                          gap: "6px",
                                          boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                                          transition: "all 0.2s"
                                        }}
                                        onMouseEnter={(e) => {
                                          if (!isSelected) {
                                            e.currentTarget.style.background = "#eef2ff";
                                          }
                                        }}
                                        onMouseLeave={(e) => {
                                          if (!isSelected) {
                                            e.currentTarget.style.background = "#f8fafc";
                                          }
                                        }}
                                      >
                                        Analyze Details <FontAwesomeIcon icon={faEye} />
                                      </button>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* ================= RIGHT DRAWER (Smooth Slide-In Panel) ================= */}
                  {this.state.InsightDetailsShow && (
                    <div style={{
                      width: "420px",
                      borderLeft: "1px solid #e2e8f0",
                      background: "#ffffff",
                      display: "flex",
                      flexDirection: "column",
                      height: "100%",
                      boxShadow: "-10px 0 30px -15px rgba(0,0,0,0.1)",
                      animation: "slideLeft 0.3s cubic-bezier(0.16, 1, 0.3, 1)",
                      zIndex: 10
                    }}>
                      {/* Drawer Header */}
                      <div style={{
                        padding: "24px",
                        borderBottom: "1px solid #f1f5f9",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between"
                      }}>
                        <div>
                          <span style={{ fontSize: "10px", textTransform: "uppercase", trackingSpacing: "1px", color: "#64748b", fontWeight: "700" }}>
                            Target Details
                          </span>
                          <h4 style={{ margin: "4px 0 0 0", fontSize: "16px", fontWeight: "700", color: "#0f172a" }}>
                            Btn: <span style={{ color: "#4f46e5" }}>{this.state.activeInsightBtnName}</span>
                          </h4>
                        </div>

                        <button
                          onClick={() => this.setState({ InsightDetailsShow: false, insightDataDetails: [] })}
                          style={{
                            background: "none",
                            border: "none",
                            color: "#94a3b8",
                            cursor: "pointer",
                            fontSize: "16px"
                          }}
                        >
                          <FontAwesomeIcon icon={faTimes} />
                        </button>
                      </div>

                      {/* Drawer Body Container */}
                      <div style={{ flex: 1, overflowY: "auto", padding: "24px", display: "flex", flexDirection: "column" }}>
                        {this.state.insightDetailsLoading ? (
                          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flex: 1 }}>
                            <Spining />
                          </div>
                        ) : Object.keys(this.state.insightDataDetails).length > 0 ?
                          (
                            <div style={{ display: "flex", flexDirection: "column", gap: "12px", height: "100%" }}>

                              {/* Search + Download toolbar */}
                              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                <input
                                  type="text"
                                  placeholder="Search mobile / phone..."
                                  value={this.state.detailSearchQuery}
                                  onChange={e => this.setState({ detailSearchQuery: e.target.value })}
                                  style={{
                                    flex: 1,
                                    padding: "7px 12px",
                                    border: "1px solid #e2e8f0",
                                    borderRadius: "8px",
                                    fontSize: "12px",
                                    color: "#334155",
                                    outline: "none",
                                    background: "#f8fafc"
                                  }}
                                />
                                <button
                                  onClick={this.downloadDetailData}
                                  title="Download CSV"
                                  style={{
                                    padding: "7px 12px",
                                    border: "1px solid #e2e8f0",
                                    borderRadius: "8px",
                                    background: "#fff",
                                    color: "#4f46e5",
                                    cursor: "pointer",
                                    fontSize: "13px",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "5px",
                                    fontWeight: "600",
                                    whiteSpace: "nowrap"
                                  }}
                                  onMouseEnter={e => { e.currentTarget.style.background = "#f5f3ff"; e.currentTarget.style.borderColor = "#4f46e5"; }}
                                  onMouseLeave={e => { e.currentTarget.style.background = "#fff"; e.currentTarget.style.borderColor = "#e2e8f0"; }}
                                >
                                  <FontAwesomeIcon icon={faDownload} /> Export
                                </button>
                              </div>

                              {/* Simplified Cards instead of nested messy tables */}
                              <div style={{ flex: 1, overflowY: "auto", display: "flex", flexDirection: "column", gap: "10px" }}>
                                {this.state.insightDataDetails?.btn_detail?.filter(row => {
                                  const q = this.state.detailSearchQuery.toLowerCase();
                                  return !q || String(row.mobile ?? "").toLowerCase().includes(q);
                                }).map((row, ri) => (
                                  <div key={ri} style={{
                                    padding: "14px",
                                    background: "#f8fafc",
                                    border: "1px solid #f1f5f9",
                                    borderRadius: "10px",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center"
                                  }}>
                                    <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
                                      <span style={{ fontSize: "13px", fontWeight: "600", color: "#334155" }}>{row.mobile}</span>
                                      <span style={{ fontSize: "10px", color: "#94a3b8", fontFamily: "monospace" }}>ID: {row._id}</span>
                                      {row.createdAt && (
                                        <span style={{ fontSize: "10px", color: "#64748b", display: "flex", alignItems: "center", gap: "3px" }}>
                                          <FontAwesomeIcon icon={faCalendarAlt} style={{ fontSize: "9px" }} />
                                          {new Date(row.createdAt).toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" })}
                                        </span>
                                      )}
                                    </div>
                                    <div style={{ textAlign: "right" }}>
                                      <span style={{ fontSize: "11px", color: "#64748b", display: "block" }}>Clicks</span>
                                      <span style={{ fontSize: "14px", fontWeight: "700", color: "#4f46e5" }}>{row.click_count}</span>
                                    </div>
                                  </div>
                                ))}

                                {this.state?.insightDataDetails?.cta_detail?.filter(row => {
                                  const q = this.state.detailSearchQuery.toLowerCase();
                                  return !q || String(row.phone_number ?? "").toLowerCase().includes(q);
                                }).map((row, ri) => (
                                  <div key={ri} style={{
                                    padding: "14px",
                                    background: "#f8fafc",
                                    border: "1px solid #f1f5f9",
                                    borderRadius: "10px",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    gap: "10px"
                                  }}>
                                    <div style={{ display: "flex", flexDirection: "column", gap: "3px", minWidth: 0 }}>
                                      <span style={{ fontSize: "13px", fontWeight: "600", color: "#334155" }}>{row.phone_number}</span>
                                      <span style={{ fontSize: "10px", color: "#94a3b8", fontFamily: "monospace" }}>ID: {row._id}</span>
                                      {row.short_url && (
                                        <a
                                          href={row.short_url}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          title={row.main_url}
                                          style={{
                                            fontSize: "10px", color: "#2563eb",
                                            overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
                                            maxWidth: "220px",
                                          }}
                                        >
                                          {row.short_url}
                                        </a>
                                      )}
                                      {row.created && (
                                        <span style={{ fontSize: "10px", color: "#64748b", display: "flex", alignItems: "center", gap: "3px" }}>
                                          <FontAwesomeIcon icon={faCalendarAlt} style={{ fontSize: "9px" }} />
                                          {new Date(row.created).toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" })}
                                        </span>
                                      )}
                                    </div>
                                    <div style={{ textAlign: "right", flexShrink: 0 }}>
                                      <span style={{ fontSize: "11px", color: "#64748b", display: "block" }}>Clicks</span>
                                      <span style={{ fontSize: "14px", fontWeight: "700", color: "#4f46e5" }}>{row.url_clickcount}</span>
                                    </div>
                                  </div>
                                ))}
                              </div>

                              {/* Pagination — always visible when data is present */}
                              <div style={{
                                paddingTop: "16px",
                                borderTop: "1px solid #f1f5f9",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                flexWrap: "wrap",
                                gap: "8px"
                              }}>
                                {/* Left: page info */}
                                <span style={{ fontSize: "11px", color: "#64748b" }}>
                                  Page <b style={{ color: "#4f46e5" }}>{this.state.detailCurrentPage}</b>
                                  {this.state.detailTotalPages > 1 && (
                                    <> / <b style={{ color: "#4f46e5" }}>{this.state.detailTotalPages}</b></>
                                  )}
                                  {this.state.detailTotalRecords > 0 && (
                                    <span style={{ color: "#94a3b8", marginLeft: "4px" }}>({this.state.detailTotalRecords} total)</span>
                                  )}
                                </span>

                                {/* Right: prev / page pills / next */}
                                <div style={{ display: "flex", gap: "4px", alignItems: "center" }}>
                                  {/* Prev */}
                                  <button
                                    onClick={() => this.handleDetailPageChange(this.state.detailCurrentPage - 1)}
                                    disabled={this.state.detailCurrentPage === 1}
                                    style={{
                                      padding: "4px 10px",
                                      border: "1px solid #e2e8f0",
                                      background: this.state.detailCurrentPage === 1 ? "#f8fafc" : "#fff",
                                      color: this.state.detailCurrentPage === 1 ? "#cbd5e1" : "#4f46e5",
                                      borderRadius: "6px",
                                      fontSize: "11px",
                                      fontWeight: "600",
                                      cursor: this.state.detailCurrentPage === 1 ? "not-allowed" : "pointer"
                                    }}
                                  >
                                    ‹ Prev
                                  </button>

                                  {/* Page number pills — only when total pages known */}
                                  {this.state.detailTotalPages > 1 && (
                                    Array.from({ length: this.state.detailTotalPages }, (_, i) => i + 1)
                                      .filter(p => p === 1 || p === this.state.detailTotalPages || Math.abs(p - this.state.detailCurrentPage) <= 1)
                                      .reduce((acc, p, idx, arr) => {
                                        if (idx > 0 && p - arr[idx - 1] > 1) acc.push("...");
                                        acc.push(p);
                                        return acc;
                                      }, [])
                                      .map((p, idx) =>
                                        p === "..." ? (
                                          <span key={`e-${idx}`} style={{ fontSize: "11px", color: "#94a3b8", padding: "0 2px" }}>…</span>
                                        ) : (
                                          <button
                                            key={p}
                                            onClick={() => this.handleDetailPageChange(p)}
                                            style={{
                                              padding: "4px 8px",
                                              border: "1px solid",
                                              borderColor: this.state.detailCurrentPage === p ? "#4f46e5" : "#e2e8f0",
                                              background: this.state.detailCurrentPage === p ? "#4f46e5" : "#fff",
                                              color: this.state.detailCurrentPage === p ? "#fff" : "#475569",
                                              borderRadius: "6px",
                                              fontSize: "11px",
                                              fontWeight: this.state.detailCurrentPage === p ? "700" : "400",
                                              cursor: "pointer",
                                              minWidth: "28px"
                                            }}
                                          >
                                            {p}
                                          </button>
                                        )
                                      )
                                  )}

                                  {/* Next */}
                                  <button
                                    onClick={() => this.handleDetailPageChange(this.state.detailCurrentPage + 1)}
                                    disabled={this.state.detailTotalPages > 1 && this.state.detailCurrentPage >= this.state.detailTotalPages}
                                    style={{
                                      padding: "4px 10px",
                                      border: "1px solid #e2e8f0",
                                      background: (this.state.detailTotalPages > 1 && this.state.detailCurrentPage >= this.state.detailTotalPages) ? "#f8fafc" : "#fff",
                                      color: (this.state.detailTotalPages > 1 && this.state.detailCurrentPage >= this.state.detailTotalPages) ? "#cbd5e1" : "#4f46e5",
                                      borderRadius: "6px",
                                      fontSize: "11px",
                                      fontWeight: "600",
                                      cursor: (this.state.detailTotalPages > 1 && this.state.detailCurrentPage >= this.state.detailTotalPages) ? "not-allowed" : "pointer"
                                    }}
                                  >
                                    Next ›
                                  </button>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div style={{ textAlign: "center", margin: "auto 0" }}>
                              <img alt="Empty State" src={EmptyImg} style={{ width: "64px", opacity: 0.4, marginBottom: "12px" }} />
                              <p style={{ color: "#94a3b8", fontSize: "13px" }}>No click logs available.</p>
                            </div>
                          )}
                      </div>
                    </div>
                  )}
                </div>

                {/* Keyframe slides injection for CSS */}
                <style>{`
      @keyframes slideLeft {
        from { transform: translateX(100%); opacity: 0; }
        to { transform: translateX(0); opacity: 1; }
      }
      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }
    `}</style>
              </div>
            )}

            {this.state.clickReportModal && (
              <div className="insight-overlay" style={{
                position: "fixed",
                top: 0, left: 0, right: 0, bottom: 0,
                backgroundColor: "rgba(15, 23, 42, 0.4)",
                backdropFilter: "blur(8px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 1000,
                animation: "fadeIn 0.2s ease-out"
              }}>
                <div style={{
                  position: "relative",
                  backgroundColor: "#ffffff",
                  borderRadius: "16px",
                  boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.05)",
                  width: "95%",
                  maxWidth: "900px",
                  maxHeight: "85vh",
                  display: "flex",
                  flexDirection: "column",
                  overflow: "hidden",
                  fontFamily: "Inter, system-ui, -apple-system, sans-serif"
                }}>
                  {/* Header */}
                  <div style={{
                    padding: "20px 28px",
                    borderBottom: "1px solid #f1f5f9",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  }}>
                    <div>
                      <span style={{ fontSize: "11px", textTransform: "uppercase", letterSpacing: "1.5px", color: "#6366f1", fontWeight: "700" }}>
                        RCS Analytics
                      </span>
                      <h2 style={{ fontSize: "19px", fontWeight: "800", color: "#0f172a", margin: "4px 0 0 0", letterSpacing: "-0.5px" }}>
                        Click Report Summary
                      </h2>
                    </div>
                    <button
                      onClick={this.closeClickReportModal}
                      style={{ background: "#f1f5f9", border: "none", color: "#64748b", borderRadius: "50%", width: "34px", height: "34px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", transition: "all 0.2s" }}
                      onMouseEnter={(e) => { e.currentTarget.style.background = "#e2e8f0"; e.currentTarget.style.color = "#0f172a"; }}
                      onMouseLeave={(e) => { e.currentTarget.style.background = "#f1f5f9"; e.currentTarget.style.color = "#64748b"; }}
                    >
                      <FontAwesomeIcon icon={faTimes} />
                    </button>
                  </div>

                  {/* Body */}
                  <div style={{ padding: "24px 28px", flex: 1, overflowY: "auto" }}>
                    {this.state.clickReportLoading ? (
                      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", gap: "12px", padding: "60px 0" }}>
                        <FontAwesomeIcon icon={faSpinner} spin style={{ fontSize: "26px", color: "#4f46e5" }} />
                        <span style={{ color: "#64748b", fontSize: "13px" }}>Loading click report…</span>
                      </div>
                    ) : this.state.clickReportSummary.length > 0 ? (
                      <div style={{ border: "1px solid #f1f5f9", borderRadius: "12px", overflow: "hidden" }}>
                        <table style={{ width: "100%", borderCollapse: "collapse", textAlign: "left" }}>
                          <thead style={{ background: "#f8fafc" }}>
                            <tr style={{ borderBottom: "1px solid #e2e8f0" }}>
                              <th style={{ padding: "12px 18px", fontSize: "11px", fontWeight: "700", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px" }}>Template ID</th>
                              <th style={{ padding: "12px 18px", fontSize: "11px", fontWeight: "700", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px" }}>Total Clicks</th>
                              <th style={{ padding: "12px 18px", fontSize: "11px", fontWeight: "700", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px" }}>First Click</th>
                              <th style={{ padding: "12px 18px", fontSize: "11px", fontWeight: "700", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px" }}>Last Click</th>
                              <th style={{ padding: "12px 18px", fontSize: "11px", fontWeight: "700", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px", textAlign: "right" }}>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.clickReportSummary.map((row, i) => (
                              <tr key={i} style={{ borderBottom: "1px solid #f1f5f9" }}
                                onMouseEnter={e => e.currentTarget.style.background = "#f8fafc"}
                                onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                              >
                                <td style={{ padding: "14px 18px", fontSize: "13px", fontWeight: "600", color: "#334155" }}>{row.template_id}</td>
                                <td style={{ padding: "14px 18px" }}>
                                  <span style={{ background: "#eef2ff", color: "#4338ca", padding: "4px 10px", borderRadius: "100px", fontSize: "12px", fontWeight: "700" }}>
                                    {row.totalClicks}
                                  </span>
                                </td>
                                <td style={{ padding: "14px 18px", fontSize: "12px", color: "#475569" }}>{row.firstClick ? dayjs(row.firstClick).format("DD/MM/YYYY h:mm A") : "—"}</td>
                                <td style={{ padding: "14px 18px", fontSize: "12px", color: "#475569" }}>{row.lastClick ? dayjs(row.lastClick).format("DD/MM/YYYY h:mm A") : "—"}</td>
                                <td style={{ padding: "14px 18px", textAlign: "right" }}>
                                  <div style={{ display: "inline-flex", gap: "8px" }}>
                                    <Link
                                      to={`/dashboard/campaign/rcs-click-report/${encodeURIComponent(row.template_id)}/${this.currentDate(this.state.startDate)}/${this.currentDate(this.state.endDate)}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{
                                        border: "none", background: "#4f46e5", color: "#fff",
                                        padding: "7px 14px", borderRadius: "8px", fontSize: "12px", fontWeight: "600",
                                        cursor: "pointer", display: "inline-flex", alignItems: "center", gap: "6px",
                                        textDecoration: "none"
                                      }}
                                    >
                                      View <FontAwesomeIcon icon={faEye} />
                                    </Link>
                                    <button
                                      type="button"
                                      disabled={!!this.state.clickReportDownloading[row.template_id]}
                                      onClick={() => this.downloadClickReportDetail(row.template_id)}
                                      style={{
                                        border: "1px solid #e2e8f0", background: "#fff", color: "#4f46e5",
                                        padding: "7px 14px", borderRadius: "8px", fontSize: "12px", fontWeight: "600",
                                        cursor: this.state.clickReportDownloading[row.template_id] ? "not-allowed" : "pointer",
                                        display: "inline-flex", alignItems: "center", gap: "6px"
                                      }}
                                    >
                                      Download <FontAwesomeIcon
                                        icon={this.state.clickReportDownloading[row.template_id] ? faSpinner : faDownload}
                                        spin={!!this.state.clickReportDownloading[row.template_id]}
                                      />
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <div style={{ textAlign: "center", padding: "60px 0" }}>
                        <img alt="Empty State" src={EmptyImg} style={{ width: "64px", opacity: 0.4, marginBottom: "12px" }} />
                        <p style={{ color: "#94a3b8", fontSize: "13px" }}>No click report data available.</p>
                      </div>
                    )}
                  </div>

                  {/* Footer / pagination */}
                  {this.state.clickReportSummary.length > 0 && (
                    <div style={{ padding: "14px 28px", borderTop: "1px solid #f1f5f9", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <span style={{ fontSize: "13px", color: "#334155", fontWeight: "600" }}>
                        Page <span style={{ color: "#4f46e5" }}>{this.state.clickReportPage}</span>
                        {this.state.clickReportTotalPages > 1 && <> of <span style={{ color: "#4f46e5" }}>{this.state.clickReportTotalPages}</span></>}
                        {/* <span style={{ color: "#94a3b8", fontWeight: "400" }}> ({this.state.clickReportTotalCount} total)</span> */}
                      </span>
                      <div style={{ display: "flex", gap: "6px" }}>
                        <button
                          onClick={() => this.handleClickReportPageChange(this.state.clickReportPage - 1)}
                          disabled={this.state.clickReportPage === 1}
                          style={{
                            height: "34px", padding: "0 14px", border: "1px solid #e2e8f0", borderRadius: "8px",
                            background: this.state.clickReportPage === 1 ? "#f8fafc" : "#fff",
                            color: this.state.clickReportPage === 1 ? "#cbd5e1" : "#4f46e5",
                            fontSize: "13px", fontWeight: "600",
                            cursor: this.state.clickReportPage === 1 ? "not-allowed" : "pointer"
                          }}
                        >
                          <FontAwesomeIcon icon={faChevronLeft} style={{ fontSize: "10px", marginRight: "5px" }} /> Prev
                        </button>
                        <button
                          onClick={() => this.handleClickReportPageChange(this.state.clickReportPage + 1)}
                          disabled={this.state.clickReportTotalPages > 1 && this.state.clickReportPage >= this.state.clickReportTotalPages}
                          style={{
                            height: "34px", padding: "0 14px", border: "1px solid #e2e8f0", borderRadius: "8px",
                            background: (this.state.clickReportTotalPages > 1 && this.state.clickReportPage >= this.state.clickReportTotalPages) ? "#f8fafc" : "#fff",
                            color: (this.state.clickReportTotalPages > 1 && this.state.clickReportPage >= this.state.clickReportTotalPages) ? "#cbd5e1" : "#4f46e5",
                            fontSize: "13px", fontWeight: "600",
                            cursor: (this.state.clickReportTotalPages > 1 && this.state.clickReportPage >= this.state.clickReportTotalPages) ? "not-allowed" : "pointer"
                          }}
                        >
                          Next <FontAwesomeIcon icon={faChevronRight} style={{ fontSize: "10px", marginLeft: "5px" }} />
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}

            {this.state.contactCountPopup && (
              <div className="insight-overlay">
                <div className="insight-popup">
                  <div
                    className="close-btn"
                    onClick={() => this.setState({ contactCountPopup: false, contactCountSummary: "" })}
                  >
                    <FontAwesomeIcon icon={faTimes} />
                  </div>


                  {/* YOUR EXISTING CODE STARTS HERE */}

                  <div className="insight-content">
                    <div className="insights-wrapper">

                      {/* 🔹 HEADER */}
                      <div style={{ marginBottom: "10px" }}>
                        {this.state.user_id === 19976 || this.state.user_id === 19977 ?
                          <h3 style={{ margin: 0 }}>
                            Contact Count Summary / {this.state.contactCountSummary?.id}
                          </h3> :
                          <h3 style={{ margin: 0 }}>
                            Message Content / {this.state.contactCountSummary?.id}
                          </h3>}
                      </div>

                      {/* 🔹 MESSAGE CONTENT */}
                      <div
                        style={{
                          background: "#f8fafc",
                          padding: "12px",
                          borderRadius: "6px",
                          marginBottom: "15px",
                          border: "1px solid #eee",
                          fontSize: "14px",
                          lineHeight: "1.5"
                        }}
                      >
                        <strong>Message Content:</strong>
                        <div style={{ marginTop: "5px" }}>
                          {this.state.contactCountSummary?.text_message}
                        </div>
                      </div>

                      {/* 🔹 TABLE */}
                      {(this.state.user_id === 19976 || this.state.user_id === 19977) && (

                        this.state.contactCountSummary?.number_count &&
                          this.state.contactCountSummary.number_count.total_number > 0 ? (

                          <div
                            style={{
                              border: "1px solid #eee",
                              borderRadius: "8px",
                              overflow: "hidden"
                            }}
                          >
                            <table style={{ width: "100%", borderCollapse: "collapse" }}>

                              {/* HEADER */}
                              <thead style={{ background: "#f1f5f9" }}>
                                <tr>
                                  <th style={{ padding: "12px", textAlign: "left", color: "#6C757D" }}>Contact Count</th>
                                  <th style={{ padding: "12px", textAlign: "left", color: "#6C757D" }}>Delivered</th>
                                  <th style={{ padding: "12px", textAlign: "left", color: "#6C757D" }}>Failed</th>
                                  <th style={{ padding: "12px", textAlign: "left", color: "#6C757D" }}>Optout</th>
                                  <th style={{ padding: "12px", textAlign: "left", color: "#6C757D" }}>DND</th>
                                  <th style={{ padding: "12px", textAlign: "left", color: "#6C757D" }}>Other</th>
                                </tr>
                              </thead>

                              {/* BODY */}
                              <tbody>
                                <tr>
                                  <td style={{ padding: "12px", borderTop: "1px solid #eee" }}>
                                    {this.state.contactCountSummary.number_count.total_number}
                                  </td>
                                  <td style={{ padding: "12px", borderTop: "1px solid #eee" }}>
                                    {this.state.contactCountSummary.number_count.delivered}
                                  </td>
                                  <td style={{ padding: "12px", borderTop: "1px solid #eee" }}>
                                    {this.state.contactCountSummary.number_count.failed}
                                  </td>
                                  <td style={{ padding: "12px", borderTop: "1px solid #eee" }}>
                                    {this.state.contactCountSummary.number_count.optout}
                                  </td>
                                  <td style={{ padding: "12px", borderTop: "1px solid #eee" }}>
                                    {this.state.contactCountSummary.number_count.dnd}
                                  </td>
                                  <td style={{ padding: "12px", borderTop: "1px solid #eee" }}>
                                    {this.state.contactCountSummary.number_count.other}
                                  </td>
                                </tr>
                              </tbody>

                            </table>
                          </div>

                        ) : (

                          <div style={{ textAlign: "center", marginTop: "20px" }}>
                            <img
                              src={EmptyImg}
                              alt="Empty Data"
                              style={{ width: "120px", marginBottom: "10px" }}
                            />
                            <p>No Record Found</p>
                          </div>

                        )

                      )}


                    </div>
                  </div>

                  {/* YOUR EXISTING CODE ENDS HERE */}
                </div>
              </div>
            )}


            <DashboardFooter />
          </div>
        </div>


      </>
    );
  }
}

export default CampaignList;
